//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IFormAssignmentsClient {
    get(patientId: number | undefined): Promise<FormAssignmentVm>;
    getFormAssignmentsIndexVm(query: GetFormAssignmentsIndexVmQuery | null | undefined): Promise<FormsAssignmentIndexVm>;
    getUserProfiles(locationId: number | undefined): Promise<RwUserProfile[]>;
    create(command: CreateFormAssignmentCommand): Promise<Unit>;
    updateOrder(command: UpdateFormAssignmentOrderCommand): Promise<Unit>;
    deleteAllFormAssignments(command: DeleteAllFormAssignmentsForPatientCommand): Promise<Unit>;
    updatePatientConsent(command: UpdatePatientConsentCommand): Promise<Unit>;
    updateUserProfileId(command: UpdateFormAssignmentCommand): Promise<Unit>;
    setDueDateOnFormAssignment(command: SetDueDateOnFormAssignmentCommand): Promise<Unit>;
    delete(id: string, command: DeleteFormAssignmentCommand): Promise<Unit>;
}

export class FormAssignmentsClient implements IFormAssignmentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(patientId: number | undefined, cancelToken?: CancelToken): Promise<FormAssignmentVm> {
        let url_ = this.baseUrl + "/api/FormAssignments/Get?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FormAssignmentVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormAssignmentVm.fromJS(resultData200);
            return Promise.resolve<FormAssignmentVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormAssignmentVm>(null as any);
    }

    getFormAssignmentsIndexVm(query: GetFormAssignmentsIndexVmQuery | null | undefined, cancelToken?: CancelToken): Promise<FormsAssignmentIndexVm> {
        let url_ = this.baseUrl + "/api/FormAssignments/GetFormAssignmentsIndexVm?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormAssignmentsIndexVm(_response);
        });
    }

    protected processGetFormAssignmentsIndexVm(response: AxiosResponse): Promise<FormsAssignmentIndexVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormsAssignmentIndexVm.fromJS(resultData200);
            return Promise.resolve<FormsAssignmentIndexVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormsAssignmentIndexVm>(null as any);
    }

    getUserProfiles(locationId: number | undefined, cancelToken?: CancelToken): Promise<RwUserProfile[]> {
        let url_ = this.baseUrl + "/api/FormAssignments/GetUserProfiles?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserProfiles(_response);
        });
    }

    protected processGetUserProfiles(response: AxiosResponse): Promise<RwUserProfile[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RwUserProfile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RwUserProfile[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RwUserProfile[]>(null as any);
    }

    create(command: CreateFormAssignmentCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/FormAssignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    updateOrder(command: UpdateFormAssignmentOrderCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/FormAssignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrder(_response);
        });
    }

    protected processUpdateOrder(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    deleteAllFormAssignments(command: DeleteAllFormAssignmentsForPatientCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/FormAssignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAllFormAssignments(_response);
        });
    }

    protected processDeleteAllFormAssignments(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    updatePatientConsent(command: UpdatePatientConsentCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/FormAssignments/UpdatePatientConsent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePatientConsent(_response);
        });
    }

    protected processUpdatePatientConsent(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    updateUserProfileId(command: UpdateFormAssignmentCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/FormAssignments/UpdateUserProfileId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserProfileId(_response);
        });
    }

    protected processUpdateUserProfileId(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    setDueDateOnFormAssignment(command: SetDueDateOnFormAssignmentCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/FormAssignments/SetDueDateOnFormAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDueDateOnFormAssignment(_response);
        });
    }

    protected processSetDueDateOnFormAssignment(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    delete(id: string, command: DeleteFormAssignmentCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/FormAssignments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }
}

export interface IFormFieldsClient {
    getPmsSystemVm(formId: string | undefined, getFormFields: boolean | undefined): Promise<PmsSystemVm>;
    create(command: CreateFormFieldCommand): Promise<boolean>;
}

export class FormFieldsClient implements IFormFieldsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPmsSystemVm(formId: string | undefined, getFormFields: boolean | undefined, cancelToken?: CancelToken): Promise<PmsSystemVm> {
        let url_ = this.baseUrl + "/api/FormFields/GetPmsSystemVm?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "FormId=" + encodeURIComponent("" + formId) + "&";
        if (getFormFields === null)
            throw new Error("The parameter 'getFormFields' cannot be null.");
        else if (getFormFields !== undefined)
            url_ += "GetFormFields=" + encodeURIComponent("" + getFormFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPmsSystemVm(_response);
        });
    }

    protected processGetPmsSystemVm(response: AxiosResponse): Promise<PmsSystemVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PmsSystemVm.fromJS(resultData200);
            return Promise.resolve<PmsSystemVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PmsSystemVm>(null as any);
    }

    create(command: CreateFormFieldCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/FormFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IFormPacketsClient {
    get(id: string | null | undefined, locationId: number | undefined): Promise<FormPacketDto>;
    create(command: CreateFormPacketCommand): Promise<string>;
    ensurePublicPacketForLocation(publicPacketForLocationCommand: EnsurePublicPacketForLocationCommand): Promise<string>;
    list(page: number | undefined, pageSize: number | undefined, locationId: number | undefined, search: string | null | undefined, sortCol: string | null | undefined, sortDir: string | null | undefined, includeNames: boolean | undefined, formLocationId: number | undefined, client: ClientApp | null | undefined): Promise<FormPacketsVm>;
    getPacketShortUrls(packetId: string | undefined): Promise<ShortUrlDto[]>;
    getPublicPacketShortUrlForLocation(locationId: number | undefined): Promise<string>;
    delete(id: string): Promise<Unit>;
    update(id: string, command: UpdateFormPacketCommand): Promise<string>;
    createLink(command: CreatePacketLinkCommand): Promise<string>;
    getFormPacketsIndexVm(locationId: number | undefined): Promise<FormPacketsIndexVm>;
    getFormPacketLocations(formIds: string[] | undefined): Promise<number[]>;
    getFormPacketsWithUrls(locationId: number | undefined): Promise<FormPacketWithUrlVm[]>;
}

export class FormPacketsClient implements IFormPacketsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(id: string | null | undefined, locationId: number | undefined, cancelToken?: CancelToken): Promise<FormPacketDto> {
        let url_ = this.baseUrl + "/api/FormPackets?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FormPacketDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormPacketDto.fromJS(resultData200);
            return Promise.resolve<FormPacketDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormPacketDto>(null as any);
    }

    create(command: CreateFormPacketCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/FormPackets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    ensurePublicPacketForLocation(publicPacketForLocationCommand: EnsurePublicPacketForLocationCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/FormPackets/EnsurePublicPacket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(publicPacketForLocationCommand);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnsurePublicPacketForLocation(_response);
        });
    }

    protected processEnsurePublicPacketForLocation(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    list(page: number | undefined, pageSize: number | undefined, locationId: number | undefined, search: string | null | undefined, sortCol: string | null | undefined, sortDir: string | null | undefined, includeNames: boolean | undefined, formLocationId: number | undefined, client: ClientApp | null | undefined, cancelToken?: CancelToken): Promise<FormPacketsVm> {
        let url_ = this.baseUrl + "/api/FormPackets/List?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sortCol !== undefined && sortCol !== null)
            url_ += "SortCol=" + encodeURIComponent("" + sortCol) + "&";
        if (sortDir !== undefined && sortDir !== null)
            url_ += "SortDir=" + encodeURIComponent("" + sortDir) + "&";
        if (includeNames === null)
            throw new Error("The parameter 'includeNames' cannot be null.");
        else if (includeNames !== undefined)
            url_ += "IncludeNames=" + encodeURIComponent("" + includeNames) + "&";
        if (formLocationId === null)
            throw new Error("The parameter 'formLocationId' cannot be null.");
        else if (formLocationId !== undefined)
            url_ += "FormLocationId=" + encodeURIComponent("" + formLocationId) + "&";
        if (client !== undefined && client !== null)
            url_ += "Client=" + encodeURIComponent("" + client) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<FormPacketsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormPacketsVm.fromJS(resultData200);
            return Promise.resolve<FormPacketsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormPacketsVm>(null as any);
    }

    getPacketShortUrls(packetId: string | undefined, cancelToken?: CancelToken): Promise<ShortUrlDto[]> {
        let url_ = this.baseUrl + "/api/FormPackets/GetPacketShortUrls?";
        if (packetId === null)
            throw new Error("The parameter 'packetId' cannot be null.");
        else if (packetId !== undefined)
            url_ += "PacketId=" + encodeURIComponent("" + packetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPacketShortUrls(_response);
        });
    }

    protected processGetPacketShortUrls(response: AxiosResponse): Promise<ShortUrlDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShortUrlDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ShortUrlDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShortUrlDto[]>(null as any);
    }

    getPublicPacketShortUrlForLocation(locationId: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/FormPackets/GetPublicPacketShortUrlForLocation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicPacketShortUrlForLocation(_response);
        });
    }

    protected processGetPublicPacketShortUrlForLocation(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/FormPackets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    update(id: string, command: UpdateFormPacketCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/FormPackets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createLink(command: CreatePacketLinkCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/FormPackets/CreateLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLink(_response);
        });
    }

    protected processCreateLink(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getFormPacketsIndexVm(locationId: number | undefined, cancelToken?: CancelToken): Promise<FormPacketsIndexVm> {
        let url_ = this.baseUrl + "/api/FormPackets/GetFormPacketsIndexVm?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormPacketsIndexVm(_response);
        });
    }

    protected processGetFormPacketsIndexVm(response: AxiosResponse): Promise<FormPacketsIndexVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormPacketsIndexVm.fromJS(resultData200);
            return Promise.resolve<FormPacketsIndexVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormPacketsIndexVm>(null as any);
    }

    getFormPacketLocations(formIds: string[] | undefined, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/api/FormPackets/GetFormPacketLocations?";
        if (formIds === null)
            throw new Error("The parameter 'formIds' cannot be null.");
        else if (formIds !== undefined)
            formIds && formIds.forEach(item => { url_ += "FormIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormPacketLocations(_response);
        });
    }

    protected processGetFormPacketLocations(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    getFormPacketsWithUrls(locationId: number | undefined, cancelToken?: CancelToken): Promise<FormPacketWithUrlVm[]> {
        let url_ = this.baseUrl + "/api/FormPackets/GetFormPacketsWithUrls?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormPacketsWithUrls(_response);
        });
    }

    protected processGetFormPacketsWithUrls(response: AxiosResponse): Promise<FormPacketWithUrlVm[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormPacketWithUrlVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FormPacketWithUrlVm[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormPacketWithUrlVm[]>(null as any);
    }
}

export interface IFormsClient {
    get(id: string | null | undefined, legacy: boolean | undefined, locationId: number | undefined): Promise<FormVm>;
    create(command: CreateFormCommand): Promise<string>;
    getPdf(id: string | undefined): Promise<FileResponse>;
    getOld(id: number | undefined): Promise<OldRwFormDto>;
    getForms1CustomFormAsFormTwo(id: number | undefined): Promise<string>;
    getBuiltInFormTwo(formTemplateType: FormTemplateType | undefined): Promise<string>;
    getForms1BuiltInFormAsFormTwo(id: number | undefined): Promise<string>;
    getForms1AnyTypeAsFormTwo(id: number | undefined): Promise<string>;
    getFormWithUri(id: string | null | undefined, legacy: boolean | undefined): Promise<FormWithUriDto>;
    listOld(page: number | undefined, pageSize: number | undefined, search: string | undefined, locationIds: number[] | undefined): Promise<OldRwFormsVm>;
    list(page: number | undefined, pageSize: number | undefined, search: string | null | undefined, sortCol: string | null | undefined, sortDir: string | null | undefined, filterByFormType: FormType | null | undefined, filterBySpecialty: Specialty | null | undefined, locationId: number | undefined, listType: FormListType | undefined, excludeHidden: boolean | null | undefined, client: ClientApp | null | undefined): Promise<FormsVm>;
    listTemplate(page: number | undefined, pageSize: number | undefined, search: string | undefined, sortCol: string | undefined, sortDir: string | undefined, filterByFormType: FormType | null | undefined, filterBySpecialty: Specialty | null | undefined): Promise<FormsVm>;
    getFormsIndexVm(locationId: number | undefined): Promise<FormsIndexVm>;
    getImportVm(query: GetImportVmQuery | null | undefined): Promise<ImportVm>;
    listMedications(search: string | undefined): Promise<string[]>;
    getFormShortUrls(formId: string | undefined): Promise<ShortUrlDto[]>;
    getFormFromSingleSource(query: GetFormFromSingleSourceQuery | null | undefined): Promise<FormTwo[]>;
    /**
     * @deprecated
     */
    import(command: ImportFormCommand): Promise<string>;
    importCustomForm(command: ImportCustomFormCommand): Promise<string>;
    updateImportedForm(command: UpdateImportedFormCommand): Promise<boolean>;
    importEagleSoftHealthHistoryForm(command: ImportEagleSoftHealthHistoryFormCommand): Promise<string>;
    importHealthHistoryForm(command: ImportHealthHistoryFormCommand): Promise<string>;
    importBuiltInForm(command: ImportBuiltInFormCommand): Promise<string>;
    updateFormData(id: string, command: UpdateFormDataCommand): Promise<string>;
    updateFormMedications(command: UpdateFormMedicationsCommand): Promise<Unit>;
    createFormDataAssign(command: CreateFormDataAssignCommand): Promise<string>;
    updateFormAutoSync(id: string | undefined, command: UpdateFormAutoSyncCommand): Promise<string>;
    update(id: string, command: UpdateFormCommand): Promise<string>;
    delete(id: string, command: DeleteFormCommand): Promise<Unit>;
    duplicate(id: string, command: DuplicateFormCommand): Promise<string>;
    createFormFromTemplate(command: CreateFormFromTemplateCommand): Promise<string>;
    createLink(id: string, command: CreateFormLinkCommand): Promise<string>;
    getFormLinkByForms1Id(form1Id: number | undefined, locationId: number | undefined): Promise<string>;
    getFormsLinksByLocationId(locationId: number | undefined, patientId: number | null | undefined): Promise<FormUrlDto[]>;
}

export class FormsClient implements IFormsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(id: string | null | undefined, legacy: boolean | undefined, locationId: number | undefined, cancelToken?: CancelToken): Promise<FormVm> {
        let url_ = this.baseUrl + "/api/Forms?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (legacy === null)
            throw new Error("The parameter 'legacy' cannot be null.");
        else if (legacy !== undefined)
            url_ += "Legacy=" + encodeURIComponent("" + legacy) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FormVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormVm.fromJS(resultData200);
            return Promise.resolve<FormVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormVm>(null as any);
    }

    create(command: CreateFormCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getPdf(id: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Forms/GetPdf?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPdf(_response);
        });
    }

    protected processGetPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getOld(id: number | undefined, cancelToken?: CancelToken): Promise<OldRwFormDto> {
        let url_ = this.baseUrl + "/api/Forms/GetOld?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOld(_response);
        });
    }

    protected processGetOld(response: AxiosResponse): Promise<OldRwFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OldRwFormDto.fromJS(resultData200);
            return Promise.resolve<OldRwFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OldRwFormDto>(null as any);
    }

    getForms1CustomFormAsFormTwo(id: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/GetForms1CustomFormAsFormTwo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForms1CustomFormAsFormTwo(_response);
        });
    }

    protected processGetForms1CustomFormAsFormTwo(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getBuiltInFormTwo(formTemplateType: FormTemplateType | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/GetBuiltInFormTwo?";
        if (formTemplateType === null)
            throw new Error("The parameter 'formTemplateType' cannot be null.");
        else if (formTemplateType !== undefined)
            url_ += "FormTemplateType=" + encodeURIComponent("" + formTemplateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuiltInFormTwo(_response);
        });
    }

    protected processGetBuiltInFormTwo(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getForms1BuiltInFormAsFormTwo(id: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/GetForms1BuiltInFormAsFormTwo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForms1BuiltInFormAsFormTwo(_response);
        });
    }

    protected processGetForms1BuiltInFormAsFormTwo(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getForms1AnyTypeAsFormTwo(id: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/GetForms1AnyTypeAsFormTwo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForms1AnyTypeAsFormTwo(_response);
        });
    }

    protected processGetForms1AnyTypeAsFormTwo(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getFormWithUri(id: string | null | undefined, legacy: boolean | undefined, cancelToken?: CancelToken): Promise<FormWithUriDto> {
        let url_ = this.baseUrl + "/api/Forms/GetFormWithUri?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (legacy === null)
            throw new Error("The parameter 'legacy' cannot be null.");
        else if (legacy !== undefined)
            url_ += "Legacy=" + encodeURIComponent("" + legacy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormWithUri(_response);
        });
    }

    protected processGetFormWithUri(response: AxiosResponse): Promise<FormWithUriDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormWithUriDto.fromJS(resultData200);
            return Promise.resolve<FormWithUriDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormWithUriDto>(null as any);
    }

    listOld(page: number | undefined, pageSize: number | undefined, search: string | undefined, locationIds: number[] | undefined, cancelToken?: CancelToken): Promise<OldRwFormsVm> {
        let url_ = this.baseUrl + "/api/Forms/ListOld?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (locationIds === null)
            throw new Error("The parameter 'locationIds' cannot be null.");
        else if (locationIds !== undefined)
            locationIds && locationIds.forEach(item => { url_ += "LocationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListOld(_response);
        });
    }

    protected processListOld(response: AxiosResponse): Promise<OldRwFormsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OldRwFormsVm.fromJS(resultData200);
            return Promise.resolve<OldRwFormsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OldRwFormsVm>(null as any);
    }

    list(page: number | undefined, pageSize: number | undefined, search: string | null | undefined, sortCol: string | null | undefined, sortDir: string | null | undefined, filterByFormType: FormType | null | undefined, filterBySpecialty: Specialty | null | undefined, locationId: number | undefined, listType: FormListType | undefined, excludeHidden: boolean | null | undefined, client: ClientApp | null | undefined, cancelToken?: CancelToken): Promise<FormsVm> {
        let url_ = this.baseUrl + "/api/Forms/List?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sortCol !== undefined && sortCol !== null)
            url_ += "SortCol=" + encodeURIComponent("" + sortCol) + "&";
        if (sortDir !== undefined && sortDir !== null)
            url_ += "SortDir=" + encodeURIComponent("" + sortDir) + "&";
        if (filterByFormType !== undefined && filterByFormType !== null)
            url_ += "FilterByFormType=" + encodeURIComponent("" + filterByFormType) + "&";
        if (filterBySpecialty !== undefined && filterBySpecialty !== null)
            url_ += "FilterBySpecialty=" + encodeURIComponent("" + filterBySpecialty) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (listType === null)
            throw new Error("The parameter 'listType' cannot be null.");
        else if (listType !== undefined)
            url_ += "ListType=" + encodeURIComponent("" + listType) + "&";
        if (excludeHidden !== undefined && excludeHidden !== null)
            url_ += "ExcludeHidden=" + encodeURIComponent("" + excludeHidden) + "&";
        if (client !== undefined && client !== null)
            url_ += "Client=" + encodeURIComponent("" + client) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<FormsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormsVm.fromJS(resultData200);
            return Promise.resolve<FormsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormsVm>(null as any);
    }

    listTemplate(page: number | undefined, pageSize: number | undefined, search: string | undefined, sortCol: string | undefined, sortDir: string | undefined, filterByFormType: FormType | null | undefined, filterBySpecialty: Specialty | null | undefined, cancelToken?: CancelToken): Promise<FormsVm> {
        let url_ = this.baseUrl + "/api/Forms/ListTemplate?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sortCol === null)
            throw new Error("The parameter 'sortCol' cannot be null.");
        else if (sortCol !== undefined)
            url_ += "SortCol=" + encodeURIComponent("" + sortCol) + "&";
        if (sortDir === null)
            throw new Error("The parameter 'sortDir' cannot be null.");
        else if (sortDir !== undefined)
            url_ += "SortDir=" + encodeURIComponent("" + sortDir) + "&";
        if (filterByFormType !== undefined && filterByFormType !== null)
            url_ += "FilterByFormType=" + encodeURIComponent("" + filterByFormType) + "&";
        if (filterBySpecialty !== undefined && filterBySpecialty !== null)
            url_ += "FilterBySpecialty=" + encodeURIComponent("" + filterBySpecialty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListTemplate(_response);
        });
    }

    protected processListTemplate(response: AxiosResponse): Promise<FormsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormsVm.fromJS(resultData200);
            return Promise.resolve<FormsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormsVm>(null as any);
    }

    getFormsIndexVm(locationId: number | undefined, cancelToken?: CancelToken): Promise<FormsIndexVm> {
        let url_ = this.baseUrl + "/api/Forms/GetFormsIndexVm?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormsIndexVm(_response);
        });
    }

    protected processGetFormsIndexVm(response: AxiosResponse): Promise<FormsIndexVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormsIndexVm.fromJS(resultData200);
            return Promise.resolve<FormsIndexVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormsIndexVm>(null as any);
    }

    getImportVm(query: GetImportVmQuery | null | undefined, cancelToken?: CancelToken): Promise<ImportVm> {
        let url_ = this.baseUrl + "/api/Forms/GetImportVm?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportVm(_response);
        });
    }

    protected processGetImportVm(response: AxiosResponse): Promise<ImportVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportVm.fromJS(resultData200);
            return Promise.resolve<ImportVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportVm>(null as any);
    }

    listMedications(search: string | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Forms/ListMedications?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListMedications(_response);
        });
    }

    protected processListMedications(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getFormShortUrls(formId: string | undefined, cancelToken?: CancelToken): Promise<ShortUrlDto[]> {
        let url_ = this.baseUrl + "/api/Forms/GetFormShortUrls?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "FormId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormShortUrls(_response);
        });
    }

    protected processGetFormShortUrls(response: AxiosResponse): Promise<ShortUrlDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShortUrlDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ShortUrlDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShortUrlDto[]>(null as any);
    }

    getFormFromSingleSource(query: GetFormFromSingleSourceQuery | null | undefined, cancelToken?: CancelToken): Promise<FormTwo[]> {
        let url_ = this.baseUrl + "/api/Forms/GetFormFromSingleSource?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormFromSingleSource(_response);
        });
    }

    protected processGetFormFromSingleSource(response: AxiosResponse): Promise<FormTwo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormTwo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FormTwo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormTwo[]>(null as any);
    }

    /**
     * @deprecated
     */
    import(command: ImportFormCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    importCustomForm(command: ImportCustomFormCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/ImportCustomForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportCustomForm(_response);
        });
    }

    protected processImportCustomForm(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateImportedForm(command: UpdateImportedFormCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Forms/UpdateImportedForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateImportedForm(_response);
        });
    }

    protected processUpdateImportedForm(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    importEagleSoftHealthHistoryForm(command: ImportEagleSoftHealthHistoryFormCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/ImportEagleSoftHealthHistoryForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportEagleSoftHealthHistoryForm(_response);
        });
    }

    protected processImportEagleSoftHealthHistoryForm(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    importHealthHistoryForm(command: ImportHealthHistoryFormCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/ImportHealthHistoryForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportHealthHistoryForm(_response);
        });
    }

    protected processImportHealthHistoryForm(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    importBuiltInForm(command: ImportBuiltInFormCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/ImportBuiltInForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportBuiltInForm(_response);
        });
    }

    protected processImportBuiltInForm(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateFormData(id: string, command: UpdateFormDataCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/UpdateFormData/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFormData(_response);
        });
    }

    protected processUpdateFormData(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateFormMedications(command: UpdateFormMedicationsCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/Forms/UpdateFormMedications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFormMedications(_response);
        });
    }

    protected processUpdateFormMedications(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    createFormDataAssign(command: CreateFormDataAssignCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/CreateFormDataAssign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFormDataAssign(_response);
        });
    }

    protected processCreateFormDataAssign(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateFormAutoSync(id: string | undefined, command: UpdateFormAutoSyncCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/UpdateFormAutoSync?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFormAutoSync(_response);
        });
    }

    protected processUpdateFormAutoSync(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    update(id: string, command: UpdateFormCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    delete(id: string, command: DeleteFormCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/Forms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    duplicate(id: string, command: DuplicateFormCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/DuplicateForm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDuplicate(_response);
        });
    }

    protected processDuplicate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createFormFromTemplate(command: CreateFormFromTemplateCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/CreateFormFromTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFormFromTemplate(_response);
        });
    }

    protected processCreateFormFromTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createLink(id: string, command: CreateFormLinkCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/CreateLink/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLink(_response);
        });
    }

    protected processCreateLink(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getFormLinkByForms1Id(form1Id: number | undefined, locationId: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Forms/GetFormLinkByForms1Id?";
        if (form1Id === null)
            throw new Error("The parameter 'form1Id' cannot be null.");
        else if (form1Id !== undefined)
            url_ += "form1Id=" + encodeURIComponent("" + form1Id) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormLinkByForms1Id(_response);
        });
    }

    protected processGetFormLinkByForms1Id(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getFormsLinksByLocationId(locationId: number | undefined, patientId: number | null | undefined, cancelToken?: CancelToken): Promise<FormUrlDto[]> {
        let url_ = this.baseUrl + "/api/Forms/GetFormsLinksByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (patientId !== undefined && patientId !== null)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormsLinksByLocationId(_response);
        });
    }

    protected processGetFormsLinksByLocationId(response: AxiosResponse): Promise<FormUrlDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormUrlDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FormUrlDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormUrlDto[]>(null as any);
    }
}

export interface IFormSubmissionsClient {
    get(id: string | undefined, locationId: number | undefined): Promise<FormSubmissionDto>;
    getPdf(id: string | undefined): Promise<string>;
    getSubmittedBy(assignmentId: string | undefined): Promise<FormSubmissionSubmittedBy | null>;
    createOrUpdate(command: CreateOrUpdateFormSubmissionCommand): Promise<string>;
    list(page: number | undefined, pageSize: number | undefined, locationId: number | undefined, searchText: string | null | undefined, submissionFilter: FormSubmissionFilter | undefined, writeBackStatusList: FormSubmissionWriteBackStatus[] | null | undefined): Promise<FormSubmissionListDto[]>;
    getPmsUsersAndLocations(rwLocationIds: number[] | undefined): Promise<PmsInfoDto[]>;
    getSubmissionsVm(locationId: number | undefined): Promise<FormSubmissionsVm>;
    getUnreadSubmissionsCount(locationId: number | null | undefined): Promise<number>;
    getSubmissionsAnyUnread(locationId: number | null | undefined): Promise<boolean>;
    updateSubmissionPracticeSignatureCommand(command: UpdateSubmissionPracticeSignatureCommand): Promise<Unit>;
    changeStatusAndCompleted(command: UpdateFormSubmissionSetStatusAndCompletedCommand): Promise<Unit>;
    complete(command: CompleteSubmissionCommand): Promise<Unit>;
    getFormSubmissionsForPatient(patientId: number | undefined): Promise<FormSubmissionForPatientDto[]>;
    getFormSubmissionJson(id: string | undefined): Promise<string>;
    getLegacySubmissionsForPatient(patientId: number | undefined, locationId: number | undefined): Promise<LegacyFormSubmissionDto[]>;
}

export class FormSubmissionsClient implements IFormSubmissionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(id: string | undefined, locationId: number | undefined, cancelToken?: CancelToken): Promise<FormSubmissionDto> {
        let url_ = this.baseUrl + "/api/FormSubmissions?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FormSubmissionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormSubmissionDto.fromJS(resultData200);
            return Promise.resolve<FormSubmissionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionDto>(null as any);
    }

    getPdf(id: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/FormSubmissions/GetPdf?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPdf(_response);
        });
    }

    protected processGetPdf(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getSubmittedBy(assignmentId: string | undefined, cancelToken?: CancelToken): Promise<FormSubmissionSubmittedBy | null> {
        let url_ = this.baseUrl + "/api/FormSubmissions/GetSubmittedBy?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "AssignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubmittedBy(_response);
        });
    }

    protected processGetSubmittedBy(response: AxiosResponse): Promise<FormSubmissionSubmittedBy | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<FormSubmissionSubmittedBy | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionSubmittedBy | null>(null as any);
    }

    createOrUpdate(command: CreateOrUpdateFormSubmissionCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/FormSubmissions/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    list(page: number | undefined, pageSize: number | undefined, locationId: number | undefined, searchText: string | null | undefined, submissionFilter: FormSubmissionFilter | undefined, writeBackStatusList: FormSubmissionWriteBackStatus[] | null | undefined, cancelToken?: CancelToken): Promise<FormSubmissionListDto[]> {
        let url_ = this.baseUrl + "/api/FormSubmissions/List?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (submissionFilter === null)
            throw new Error("The parameter 'submissionFilter' cannot be null.");
        else if (submissionFilter !== undefined)
            url_ += "SubmissionFilter=" + encodeURIComponent("" + submissionFilter) + "&";
        if (writeBackStatusList !== undefined && writeBackStatusList !== null)
            writeBackStatusList && writeBackStatusList.forEach(item => { url_ += "WriteBackStatusList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<FormSubmissionListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormSubmissionListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FormSubmissionListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionListDto[]>(null as any);
    }

    getPmsUsersAndLocations(rwLocationIds: number[] | undefined, cancelToken?: CancelToken): Promise<PmsInfoDto[]> {
        let url_ = this.baseUrl + "/api/FormSubmissions/GetPmsUsersAndLocations?";
        if (rwLocationIds === null)
            throw new Error("The parameter 'rwLocationIds' cannot be null.");
        else if (rwLocationIds !== undefined)
            rwLocationIds && rwLocationIds.forEach(item => { url_ += "RwLocationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPmsUsersAndLocations(_response);
        });
    }

    protected processGetPmsUsersAndLocations(response: AxiosResponse): Promise<PmsInfoDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PmsInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PmsInfoDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PmsInfoDto[]>(null as any);
    }

    getSubmissionsVm(locationId: number | undefined, cancelToken?: CancelToken): Promise<FormSubmissionsVm> {
        let url_ = this.baseUrl + "/api/FormSubmissions/GetSubmissionsVm?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubmissionsVm(_response);
        });
    }

    protected processGetSubmissionsVm(response: AxiosResponse): Promise<FormSubmissionsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormSubmissionsVm.fromJS(resultData200);
            return Promise.resolve<FormSubmissionsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionsVm>(null as any);
    }

    getUnreadSubmissionsCount(locationId: number | null | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/FormSubmissions/GetUnreadSubmissionsCount?";
        if (locationId !== undefined && locationId !== null)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnreadSubmissionsCount(_response);
        });
    }

    protected processGetUnreadSubmissionsCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getSubmissionsAnyUnread(locationId: number | null | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/FormSubmissions/GetSubmissionsAnyUnread?";
        if (locationId !== undefined && locationId !== null)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubmissionsAnyUnread(_response);
        });
    }

    protected processGetSubmissionsAnyUnread(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateSubmissionPracticeSignatureCommand(command: UpdateSubmissionPracticeSignatureCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/FormSubmissions/UpdateSubmissionPracticeSignatureCommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSubmissionPracticeSignatureCommand(_response);
        });
    }

    protected processUpdateSubmissionPracticeSignatureCommand(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    changeStatusAndCompleted(command: UpdateFormSubmissionSetStatusAndCompletedCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/FormSubmissions/ChangeStatusAndCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeStatusAndCompleted(_response);
        });
    }

    protected processChangeStatusAndCompleted(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    complete(command: CompleteSubmissionCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/FormSubmissions/Complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComplete(_response);
        });
    }

    protected processComplete(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    getFormSubmissionsForPatient(patientId: number | undefined, cancelToken?: CancelToken): Promise<FormSubmissionForPatientDto[]> {
        let url_ = this.baseUrl + "/api/FormSubmissions/GetFormSubmissionsForPatient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormSubmissionsForPatient(_response);
        });
    }

    protected processGetFormSubmissionsForPatient(response: AxiosResponse): Promise<FormSubmissionForPatientDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormSubmissionForPatientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FormSubmissionForPatientDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionForPatientDto[]>(null as any);
    }

    getFormSubmissionJson(id: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/FormSubmissions/GetFormSubmissionJson?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormSubmissionJson(_response);
        });
    }

    protected processGetFormSubmissionJson(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getLegacySubmissionsForPatient(patientId: number | undefined, locationId: number | undefined, cancelToken?: CancelToken): Promise<LegacyFormSubmissionDto[]> {
        let url_ = this.baseUrl + "/api/FormSubmissions/GetLegacySubmissionsForPatient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLegacySubmissionsForPatient(_response);
        });
    }

    protected processGetLegacySubmissionsForPatient(response: AxiosResponse): Promise<LegacyFormSubmissionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LegacyFormSubmissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LegacyFormSubmissionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LegacyFormSubmissionDto[]>(null as any);
    }
}

export interface ILocationsClient {
    get(rwLocationId: number | null | undefined): Promise<LocationDto>;
    getForms2UpgradeEligibility(locationId: number | undefined): Promise<boolean>;
    getIsMigratedToForms2(locationId: number | undefined): Promise<boolean>;
    getFormsMigrationForceDate(locationId: number | undefined): Promise<Date | null>;
    getFormMigrationStatus(rwLocationId: number | undefined): Promise<FormsMigrationStatusDto>;
    migrateToForms2(locationId: number | undefined): Promise<Unit>;
    enableFormsMigrationBanner(locationId: number | undefined): Promise<Unit>;
    enableMigrationOfForms(locationId: number | undefined): Promise<Unit>;
    listPayers(locationId: number | undefined): Promise<RwPayer[]>;
}

export class LocationsClient implements ILocationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(rwLocationId: number | null | undefined, cancelToken?: CancelToken): Promise<LocationDto> {
        let url_ = this.baseUrl + "/api/Locations?";
        if (rwLocationId !== undefined && rwLocationId !== null)
            url_ += "RwLocationId=" + encodeURIComponent("" + rwLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<LocationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationDto.fromJS(resultData200);
            return Promise.resolve<LocationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationDto>(null as any);
    }

    getForms2UpgradeEligibility(locationId: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Locations/GetForms2UpgradeEligibility?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForms2UpgradeEligibility(_response);
        });
    }

    protected processGetForms2UpgradeEligibility(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getIsMigratedToForms2(locationId: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Locations/GetIsMigratedToForms2?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsMigratedToForms2(_response);
        });
    }

    protected processGetIsMigratedToForms2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getFormsMigrationForceDate(locationId: number | undefined, cancelToken?: CancelToken): Promise<Date | null> {
        let url_ = this.baseUrl + "/api/Locations/GetFormsMigrationForceDate?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormsMigrationForceDate(_response);
        });
    }

    protected processGetFormsMigrationForceDate(response: AxiosResponse): Promise<Date | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return Promise.resolve<Date | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Date | null>(null as any);
    }

    getFormMigrationStatus(rwLocationId: number | undefined, cancelToken?: CancelToken): Promise<FormsMigrationStatusDto> {
        let url_ = this.baseUrl + "/api/Locations/GetFormMigrationStatus?";
        if (rwLocationId === null)
            throw new Error("The parameter 'rwLocationId' cannot be null.");
        else if (rwLocationId !== undefined)
            url_ += "RwLocationId=" + encodeURIComponent("" + rwLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormMigrationStatus(_response);
        });
    }

    protected processGetFormMigrationStatus(response: AxiosResponse): Promise<FormsMigrationStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormsMigrationStatusDto.fromJS(resultData200);
            return Promise.resolve<FormsMigrationStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormsMigrationStatusDto>(null as any);
    }

    migrateToForms2(locationId: number | undefined, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/Locations/MigrateToForms2?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigrateToForms2(_response);
        });
    }

    protected processMigrateToForms2(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    enableFormsMigrationBanner(locationId: number | undefined, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/Locations/EnableFormsMigrationBanner?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnableFormsMigrationBanner(_response);
        });
    }

    protected processEnableFormsMigrationBanner(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    enableMigrationOfForms(locationId: number | undefined, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/Locations/EnableMigrationOfForms?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnableMigrationOfForms(_response);
        });
    }

    protected processEnableMigrationOfForms(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    listPayers(locationId: number | undefined, cancelToken?: CancelToken): Promise<RwPayer[]> {
        let url_ = this.baseUrl + "/api/Locations/ListPayers?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPayers(_response);
        });
    }

    protected processListPayers(response: AxiosResponse): Promise<RwPayer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RwPayer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RwPayer[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RwPayer[]>(null as any);
    }
}

export interface IOidcConfigurationClient {
    getUnwrapperedDomain(): Promise<string>;
    version(): Promise<string>;
    getConfig(): Promise<OidcSettings>;
}

export class OidcConfigurationClient implements IOidcConfigurationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUnwrapperedDomain( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/OidcConfiguration/GetUnwrapperedDomain";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnwrapperedDomain(_response);
        });
    }

    protected processGetUnwrapperedDomain(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    version( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/OidcConfiguration/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVersion(_response);
        });
    }

    protected processVersion(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getConfig( cancelToken?: CancelToken): Promise<OidcSettings> {
        let url_ = this.baseUrl + "/api/OidcConfiguration/GetConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConfig(_response);
        });
    }

    protected processGetConfig(response: AxiosResponse): Promise<OidcSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OidcSettings.fromJS(resultData200);
            return Promise.resolve<OidcSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OidcSettings>(null as any);
    }
}

export interface IPatientsClient {
    get(query: GetPatientQuery | null | undefined): Promise<PatientDto>;
    createOrUpdate(command: CreateOrUpdateFormSubmissionCommand): Promise<string>;
    getFormQuery(locationId: number | undefined, patientId: number | null | undefined, formId: string | null | undefined, packetId: string | null | undefined): Promise<string>;
    getFormListQuery(locationId: number | undefined, patientId: number | null | undefined): Promise<PatientFormDto[]>;
    getPatientFormAssignmentsForSearch(patientId: number | undefined): Promise<PatientFormAssignmentsForSearchDto>;
    getFormSubmissionJson(id: string | undefined): Promise<string>;
    getFormSubmissionJsonByFormId(formId: string | undefined): Promise<string>;
    createPatientFormAssignment(command: CreatePatientFormAssignmentCommand): Promise<Unit>;
    getPatientWithAssignmentsVM(query: GetPatientWithAssignmentsVmQuery | null | undefined): Promise<PatientsWithFormAssignmentVm>;
    getPatientSearchVm(query: GetPatientSearchVmQuery | null | undefined): Promise<PatientSearchVm>;
    invite(query: InvitePatientCommand): Promise<PatientDto>;
    login(command: LoginPatientCommand): Promise<PatientDto>;
    register(query: RegisterPatientCommand): Promise<PatientDto>;
    getPatientsSearch(searchText: string | undefined): Promise<PatientSearchDto[]>;
    verify(token: string | undefined, emailOrPhone: string | undefined, birthDate: string | undefined, rwLocationId: string | undefined, mode: Mode | undefined, isPublicLink: boolean | undefined, linkType: string | undefined, linkId: string | undefined, userId: string | null | undefined): Promise<PatientDto>;
    tokenIsValid(id: string | undefined, token: string | undefined): Promise<boolean>;
    getFormWithUri(id: string | null | undefined, legacy: boolean | undefined): Promise<FormWithUriDto>;
    logout(query: GetPatientLogoutQuery | null | undefined): Promise<Unit>;
    createPatientsFormAssignments(command: CreatePatientsFormAssignmentsCommand): Promise<Unit>;
    getPatientsWithFormsDueDate(query: GetPatientsWithFormsDueDateQuery): Promise<PatientsWithFormsDueDateLocation[]>;
    getPatientHasAssignments(patientId: number | undefined): Promise<boolean>;
    getPatientsAppointments(startDate: string | undefined, endDate: string | undefined): Promise<PatientAppointmentDto[]>;
    getPmsSystemVm(formId: string | undefined, getFormFields: boolean | undefined): Promise<PmsSystemVm>;
    getMissingPatientDataFormUrl(patientId: number | undefined, locationId: number | undefined): Promise<MissingPatientDataFormAssignmentDto>;
    processPatientMissingData(query: ProcessPatientMissingDataCommand): Promise<Unit>;
}

export class PatientsClient implements IPatientsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(query: GetPatientQuery | null | undefined, cancelToken?: CancelToken): Promise<PatientDto> {
        let url_ = this.baseUrl + "/api/Patients?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PatientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientDto.fromJS(resultData200);
            return Promise.resolve<PatientDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientDto>(null as any);
    }

    createOrUpdate(command: CreateOrUpdateFormSubmissionCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Patients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getFormQuery(locationId: number | undefined, patientId: number | null | undefined, formId: string | null | undefined, packetId: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Patients/GetFormQuery?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (patientId !== undefined && patientId !== null)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (formId !== undefined && formId !== null)
            url_ += "FormId=" + encodeURIComponent("" + formId) + "&";
        if (packetId !== undefined && packetId !== null)
            url_ += "PacketId=" + encodeURIComponent("" + packetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormQuery(_response);
        });
    }

    protected processGetFormQuery(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getFormListQuery(locationId: number | undefined, patientId: number | null | undefined, cancelToken?: CancelToken): Promise<PatientFormDto[]> {
        let url_ = this.baseUrl + "/api/Patients/GetFormListQuery?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (patientId !== undefined && patientId !== null)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormListQuery(_response);
        });
    }

    protected processGetFormListQuery(response: AxiosResponse): Promise<PatientFormDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientFormDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientFormDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientFormDto[]>(null as any);
    }

    getPatientFormAssignmentsForSearch(patientId: number | undefined, cancelToken?: CancelToken): Promise<PatientFormAssignmentsForSearchDto> {
        let url_ = this.baseUrl + "/api/Patients/GetPatientFormAssignmentsForSearch?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPatientFormAssignmentsForSearch(_response);
        });
    }

    protected processGetPatientFormAssignmentsForSearch(response: AxiosResponse): Promise<PatientFormAssignmentsForSearchDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientFormAssignmentsForSearchDto.fromJS(resultData200);
            return Promise.resolve<PatientFormAssignmentsForSearchDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientFormAssignmentsForSearchDto>(null as any);
    }

    getFormSubmissionJson(id: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Patients/GetFormSubmissionJson?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormSubmissionJson(_response);
        });
    }

    protected processGetFormSubmissionJson(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getFormSubmissionJsonByFormId(formId: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Patients/GetFormSubmissionJsonByFormId?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "FormId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormSubmissionJsonByFormId(_response);
        });
    }

    protected processGetFormSubmissionJsonByFormId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createPatientFormAssignment(command: CreatePatientFormAssignmentCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/Patients/CreatePatientFormAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePatientFormAssignment(_response);
        });
    }

    protected processCreatePatientFormAssignment(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    getPatientWithAssignmentsVM(query: GetPatientWithAssignmentsVmQuery | null | undefined, cancelToken?: CancelToken): Promise<PatientsWithFormAssignmentVm> {
        let url_ = this.baseUrl + "/api/Patients/GetPatientWithAssignmentsVM?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPatientWithAssignmentsVM(_response);
        });
    }

    protected processGetPatientWithAssignmentsVM(response: AxiosResponse): Promise<PatientsWithFormAssignmentVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientsWithFormAssignmentVm.fromJS(resultData200);
            return Promise.resolve<PatientsWithFormAssignmentVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientsWithFormAssignmentVm>(null as any);
    }

    getPatientSearchVm(query: GetPatientSearchVmQuery | null | undefined, cancelToken?: CancelToken): Promise<PatientSearchVm> {
        let url_ = this.baseUrl + "/api/Patients/GetPatientSearchVm?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPatientSearchVm(_response);
        });
    }

    protected processGetPatientSearchVm(response: AxiosResponse): Promise<PatientSearchVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientSearchVm.fromJS(resultData200);
            return Promise.resolve<PatientSearchVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSearchVm>(null as any);
    }

    invite(query: InvitePatientCommand, cancelToken?: CancelToken): Promise<PatientDto> {
        let url_ = this.baseUrl + "/api/Patients/Invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvite(_response);
        });
    }

    protected processInvite(response: AxiosResponse): Promise<PatientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientDto.fromJS(resultData200);
            return Promise.resolve<PatientDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientDto>(null as any);
    }

    login(command: LoginPatientCommand, cancelToken?: CancelToken): Promise<PatientDto> {
        let url_ = this.baseUrl + "/api/Patients/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<PatientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientDto.fromJS(resultData200);
            return Promise.resolve<PatientDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientDto>(null as any);
    }

    register(query: RegisterPatientCommand, cancelToken?: CancelToken): Promise<PatientDto> {
        let url_ = this.baseUrl + "/api/Patients/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<PatientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientDto.fromJS(resultData200);
            return Promise.resolve<PatientDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientDto>(null as any);
    }

    getPatientsSearch(searchText: string | undefined, cancelToken?: CancelToken): Promise<PatientSearchDto[]> {
        let url_ = this.baseUrl + "/api/Patients/GetPatientsSearch?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPatientsSearch(_response);
        });
    }

    protected processGetPatientsSearch(response: AxiosResponse): Promise<PatientSearchDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSearchDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientSearchDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSearchDto[]>(null as any);
    }

    verify(token: string | undefined, emailOrPhone: string | undefined, birthDate: string | undefined, rwLocationId: string | undefined, mode: Mode | undefined, isPublicLink: boolean | undefined, linkType: string | undefined, linkId: string | undefined, userId: string | null | undefined, cancelToken?: CancelToken): Promise<PatientDto> {
        let url_ = this.baseUrl + "/api/Patients/Verify?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        if (emailOrPhone === null)
            throw new Error("The parameter 'emailOrPhone' cannot be null.");
        else if (emailOrPhone !== undefined)
            url_ += "EmailOrPhone=" + encodeURIComponent("" + emailOrPhone) + "&";
        if (birthDate === null)
            throw new Error("The parameter 'birthDate' cannot be null.");
        else if (birthDate !== undefined)
            url_ += "BirthDate=" + encodeURIComponent("" + birthDate) + "&";
        if (rwLocationId === null)
            throw new Error("The parameter 'rwLocationId' cannot be null.");
        else if (rwLocationId !== undefined)
            url_ += "RwLocationId=" + encodeURIComponent("" + rwLocationId) + "&";
        if (mode === null)
            throw new Error("The parameter 'mode' cannot be null.");
        else if (mode !== undefined)
            url_ += "Mode=" + encodeURIComponent("" + mode) + "&";
        if (isPublicLink === null)
            throw new Error("The parameter 'isPublicLink' cannot be null.");
        else if (isPublicLink !== undefined)
            url_ += "IsPublicLink=" + encodeURIComponent("" + isPublicLink) + "&";
        if (linkType === null)
            throw new Error("The parameter 'linkType' cannot be null.");
        else if (linkType !== undefined)
            url_ += "LinkType=" + encodeURIComponent("" + linkType) + "&";
        if (linkId === null)
            throw new Error("The parameter 'linkId' cannot be null.");
        else if (linkId !== undefined)
            url_ += "LinkId=" + encodeURIComponent("" + linkId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: AxiosResponse): Promise<PatientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientDto.fromJS(resultData200);
            return Promise.resolve<PatientDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientDto>(null as any);
    }

    tokenIsValid(id: string | undefined, token: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Patients/TokenIsValid?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTokenIsValid(_response);
        });
    }

    protected processTokenIsValid(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getFormWithUri(id: string | null | undefined, legacy: boolean | undefined, cancelToken?: CancelToken): Promise<FormWithUriDto> {
        let url_ = this.baseUrl + "/api/Patients/GetFormWithUri?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (legacy === null)
            throw new Error("The parameter 'legacy' cannot be null.");
        else if (legacy !== undefined)
            url_ += "Legacy=" + encodeURIComponent("" + legacy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormWithUri(_response);
        });
    }

    protected processGetFormWithUri(response: AxiosResponse): Promise<FormWithUriDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormWithUriDto.fromJS(resultData200);
            return Promise.resolve<FormWithUriDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormWithUriDto>(null as any);
    }

    logout(query: GetPatientLogoutQuery | null | undefined, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/Patients/Logout?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    createPatientsFormAssignments(command: CreatePatientsFormAssignmentsCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/Patients/CreatePatientsFormAssignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePatientsFormAssignments(_response);
        });
    }

    protected processCreatePatientsFormAssignments(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    getPatientsWithFormsDueDate(query: GetPatientsWithFormsDueDateQuery, cancelToken?: CancelToken): Promise<PatientsWithFormsDueDateLocation[]> {
        let url_ = this.baseUrl + "/api/Patients/GetPatientsWithFormsDueDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPatientsWithFormsDueDate(_response);
        });
    }

    protected processGetPatientsWithFormsDueDate(response: AxiosResponse): Promise<PatientsWithFormsDueDateLocation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientsWithFormsDueDateLocation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientsWithFormsDueDateLocation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientsWithFormsDueDateLocation[]>(null as any);
    }

    getPatientHasAssignments(patientId: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Patients/GetPatientHasAssignments?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPatientHasAssignments(_response);
        });
    }

    protected processGetPatientHasAssignments(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPatientsAppointments(startDate: string | undefined, endDate: string | undefined, cancelToken?: CancelToken): Promise<PatientAppointmentDto[]> {
        let url_ = this.baseUrl + "/api/Patients/GetPatientsAppointments?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPatientsAppointments(_response);
        });
    }

    protected processGetPatientsAppointments(response: AxiosResponse): Promise<PatientAppointmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientAppointmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientAppointmentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientAppointmentDto[]>(null as any);
    }

    getPmsSystemVm(formId: string | undefined, getFormFields: boolean | undefined, cancelToken?: CancelToken): Promise<PmsSystemVm> {
        let url_ = this.baseUrl + "/api/Patients/GetPmsSystemVm?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "FormId=" + encodeURIComponent("" + formId) + "&";
        if (getFormFields === null)
            throw new Error("The parameter 'getFormFields' cannot be null.");
        else if (getFormFields !== undefined)
            url_ += "GetFormFields=" + encodeURIComponent("" + getFormFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPmsSystemVm(_response);
        });
    }

    protected processGetPmsSystemVm(response: AxiosResponse): Promise<PmsSystemVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PmsSystemVm.fromJS(resultData200);
            return Promise.resolve<PmsSystemVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PmsSystemVm>(null as any);
    }

    getMissingPatientDataFormUrl(patientId: number | undefined, locationId: number | undefined, cancelToken?: CancelToken): Promise<MissingPatientDataFormAssignmentDto> {
        let url_ = this.baseUrl + "/api/Patients/GetMissingPatientDataFormUrl?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissingPatientDataFormUrl(_response);
        });
    }

    protected processGetMissingPatientDataFormUrl(response: AxiosResponse): Promise<MissingPatientDataFormAssignmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MissingPatientDataFormAssignmentDto.fromJS(resultData200);
            return Promise.resolve<MissingPatientDataFormAssignmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MissingPatientDataFormAssignmentDto>(null as any);
    }

    processPatientMissingData(query: ProcessPatientMissingDataCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/Patients/ProcessPatientMissingData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessPatientMissingData(_response);
        });
    }

    protected processProcessPatientMissingData(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }
}

export interface IPrinterClient {
    getLocationsInfo(query: GetLocationsInfoQuery): Promise<GetLocationsInfoResponse>;
    getLocationInfo(query: GetLocationInfoQuery): Promise<GetLocationsInfoResponse>;
    getPatientList(query: GetPatientListQuery): Promise<GetPatientListResponse>;
    uploadDocumentFile(command: UploadDocumentFileCommand): Promise<UploadDocumentFileResponse>;
    addPrintedForm(command: AddPrintedFormCommand): Promise<AddPrintedFormResponse>;
    findPatient(query: GetPatientQuery2): Promise<FindPatientResponse>;
    setPrintedFormActive(query: SetPrintedFormActiveCommand): Promise<SetPrintedFormActiveResponse>;
    checkPrintedDocumentStatus(query: CheckPrintedDocumentStatusQuery): Promise<CheckPrintedDocumentStatusResponse>;
    setPrintedFormAcceptanceBlock(command: SetPrintedFormAcceptanceBlockCommand): Promise<SetPrintedFormAcceptanceBlockResponse>;
    getDefaultAcceptanceBlock(query: GetDefaultAcceptanceBlockQuery): Promise<GetDefaultAcceptanceBlockResponse>;
    setDefaultAcceptanceBlock(command: SetDefaultAcceptanceBlockCommand): Promise<Unit>;
    sendCustomEmail(command: SendEmailCommand): Promise<SendEmailResponse>;
    getPatientFormEmailTemplate(command: GetPatientFormEmailTemplateQuery): Promise<GetPatientFormEmailTemplateResponse>;
    getPrinterDownloadUrl(query: GetPrinterDownloadUrlQuery): Promise<string>;
}

export class PrinterClient implements IPrinterClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getLocationsInfo(query: GetLocationsInfoQuery, cancelToken?: CancelToken): Promise<GetLocationsInfoResponse> {
        let url_ = this.baseUrl + "/api/Printer/GetLocationsInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationsInfo(_response);
        });
    }

    protected processGetLocationsInfo(response: AxiosResponse): Promise<GetLocationsInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLocationsInfoResponse.fromJS(resultData200);
            return Promise.resolve<GetLocationsInfoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLocationsInfoResponse>(null as any);
    }

    getLocationInfo(query: GetLocationInfoQuery, cancelToken?: CancelToken): Promise<GetLocationsInfoResponse> {
        let url_ = this.baseUrl + "/api/Printer/GetLocationInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationInfo(_response);
        });
    }

    protected processGetLocationInfo(response: AxiosResponse): Promise<GetLocationsInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLocationsInfoResponse.fromJS(resultData200);
            return Promise.resolve<GetLocationsInfoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLocationsInfoResponse>(null as any);
    }

    getPatientList(query: GetPatientListQuery, cancelToken?: CancelToken): Promise<GetPatientListResponse> {
        let url_ = this.baseUrl + "/api/Printer/GetPatientList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPatientList(_response);
        });
    }

    protected processGetPatientList(response: AxiosResponse): Promise<GetPatientListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPatientListResponse.fromJS(resultData200);
            return Promise.resolve<GetPatientListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPatientListResponse>(null as any);
    }

    uploadDocumentFile(command: UploadDocumentFileCommand, cancelToken?: CancelToken): Promise<UploadDocumentFileResponse> {
        let url_ = this.baseUrl + "/api/Printer/UploadDocumentFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDocumentFile(_response);
        });
    }

    protected processUploadDocumentFile(response: AxiosResponse): Promise<UploadDocumentFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadDocumentFileResponse.fromJS(resultData200);
            return Promise.resolve<UploadDocumentFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadDocumentFileResponse>(null as any);
    }

    addPrintedForm(command: AddPrintedFormCommand, cancelToken?: CancelToken): Promise<AddPrintedFormResponse> {
        let url_ = this.baseUrl + "/api/Printer/AddPrintedForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPrintedForm(_response);
        });
    }

    protected processAddPrintedForm(response: AxiosResponse): Promise<AddPrintedFormResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddPrintedFormResponse.fromJS(resultData200);
            return Promise.resolve<AddPrintedFormResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddPrintedFormResponse>(null as any);
    }

    findPatient(query: GetPatientQuery2, cancelToken?: CancelToken): Promise<FindPatientResponse> {
        let url_ = this.baseUrl + "/api/Printer/FindPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindPatient(_response);
        });
    }

    protected processFindPatient(response: AxiosResponse): Promise<FindPatientResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FindPatientResponse.fromJS(resultData200);
            return Promise.resolve<FindPatientResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FindPatientResponse>(null as any);
    }

    setPrintedFormActive(query: SetPrintedFormActiveCommand, cancelToken?: CancelToken): Promise<SetPrintedFormActiveResponse> {
        let url_ = this.baseUrl + "/api/Printer/SetPrintedFormActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPrintedFormActive(_response);
        });
    }

    protected processSetPrintedFormActive(response: AxiosResponse): Promise<SetPrintedFormActiveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetPrintedFormActiveResponse.fromJS(resultData200);
            return Promise.resolve<SetPrintedFormActiveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetPrintedFormActiveResponse>(null as any);
    }

    checkPrintedDocumentStatus(query: CheckPrintedDocumentStatusQuery, cancelToken?: CancelToken): Promise<CheckPrintedDocumentStatusResponse> {
        let url_ = this.baseUrl + "/api/Printer/CheckPrintedDocumentStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckPrintedDocumentStatus(_response);
        });
    }

    protected processCheckPrintedDocumentStatus(response: AxiosResponse): Promise<CheckPrintedDocumentStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckPrintedDocumentStatusResponse.fromJS(resultData200);
            return Promise.resolve<CheckPrintedDocumentStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckPrintedDocumentStatusResponse>(null as any);
    }

    setPrintedFormAcceptanceBlock(command: SetPrintedFormAcceptanceBlockCommand, cancelToken?: CancelToken): Promise<SetPrintedFormAcceptanceBlockResponse> {
        let url_ = this.baseUrl + "/api/Printer/SetPrintedFormAcceptanceBlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPrintedFormAcceptanceBlock(_response);
        });
    }

    protected processSetPrintedFormAcceptanceBlock(response: AxiosResponse): Promise<SetPrintedFormAcceptanceBlockResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetPrintedFormAcceptanceBlockResponse.fromJS(resultData200);
            return Promise.resolve<SetPrintedFormAcceptanceBlockResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetPrintedFormAcceptanceBlockResponse>(null as any);
    }

    getDefaultAcceptanceBlock(query: GetDefaultAcceptanceBlockQuery, cancelToken?: CancelToken): Promise<GetDefaultAcceptanceBlockResponse> {
        let url_ = this.baseUrl + "/api/Printer/GetDefaultAcceptanceBlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefaultAcceptanceBlock(_response);
        });
    }

    protected processGetDefaultAcceptanceBlock(response: AxiosResponse): Promise<GetDefaultAcceptanceBlockResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDefaultAcceptanceBlockResponse.fromJS(resultData200);
            return Promise.resolve<GetDefaultAcceptanceBlockResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDefaultAcceptanceBlockResponse>(null as any);
    }

    setDefaultAcceptanceBlock(command: SetDefaultAcceptanceBlockCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/Printer/SetDefaultAcceptanceBlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDefaultAcceptanceBlock(_response);
        });
    }

    protected processSetDefaultAcceptanceBlock(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    sendCustomEmail(command: SendEmailCommand, cancelToken?: CancelToken): Promise<SendEmailResponse> {
        let url_ = this.baseUrl + "/api/Printer/SendCustomEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendCustomEmail(_response);
        });
    }

    protected processSendCustomEmail(response: AxiosResponse): Promise<SendEmailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendEmailResponse.fromJS(resultData200);
            return Promise.resolve<SendEmailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendEmailResponse>(null as any);
    }

    getPatientFormEmailTemplate(command: GetPatientFormEmailTemplateQuery, cancelToken?: CancelToken): Promise<GetPatientFormEmailTemplateResponse> {
        let url_ = this.baseUrl + "/api/Printer/GetPatientFormEmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPatientFormEmailTemplate(_response);
        });
    }

    protected processGetPatientFormEmailTemplate(response: AxiosResponse): Promise<GetPatientFormEmailTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPatientFormEmailTemplateResponse.fromJS(resultData200);
            return Promise.resolve<GetPatientFormEmailTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPatientFormEmailTemplateResponse>(null as any);
    }

    getPrinterDownloadUrl(query: GetPrinterDownloadUrlQuery, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Printer/GetPrinterDownloadUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPrinterDownloadUrl(_response);
        });
    }

    protected processGetPrinterDownloadUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IUsersClient {
    get(query: GetUserQuery | null | undefined): Promise<UserDto>;
    addUpdateUserPin(command: AddUpdateUserPinCommand): Promise<Unit>;
    authenticateUserByPin(command: AuthenticateUserByPinCommand): Promise<boolean>;
    loginAsPatient(patientId: number | null | undefined): Promise<boolean>;
    login(command: LoginCommand): Promise<string>;
    verify(token: string | undefined, emailOrPhone: string | undefined, birthDate: string | undefined, rwLocationId: string | undefined, mode: Mode | undefined, isPublicLink: boolean | undefined, linkType: string | null | undefined, linkId: string | null | undefined, userId: string | null | undefined): Promise<PatientDto>;
}

export class UsersClient implements IUsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(query: GetUserQuery | null | undefined, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Users?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    addUpdateUserPin(command: AddUpdateUserPinCommand, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/Users/AddUpdateUserPin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUpdateUserPin(_response);
        });
    }

    protected processAddUpdateUserPin(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    authenticateUserByPin(command: AuthenticateUserByPinCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Users/AuthenticateUserByPin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticateUserByPin(_response);
        });
    }

    protected processAuthenticateUserByPin(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    loginAsPatient(patientId: number | null | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Users/LoginAsPatient?";
        if (patientId !== undefined && patientId !== null)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginAsPatient(_response);
        });
    }

    protected processLoginAsPatient(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    login(command: LoginCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Users/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    verify(token: string | undefined, emailOrPhone: string | undefined, birthDate: string | undefined, rwLocationId: string | undefined, mode: Mode | undefined, isPublicLink: boolean | undefined, linkType: string | null | undefined, linkId: string | null | undefined, userId: string | null | undefined, cancelToken?: CancelToken): Promise<PatientDto> {
        let url_ = this.baseUrl + "/api/Users/Verify?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        if (emailOrPhone === null)
            throw new Error("The parameter 'emailOrPhone' cannot be null.");
        else if (emailOrPhone !== undefined)
            url_ += "EmailOrPhone=" + encodeURIComponent("" + emailOrPhone) + "&";
        if (birthDate === null)
            throw new Error("The parameter 'birthDate' cannot be null.");
        else if (birthDate !== undefined)
            url_ += "BirthDate=" + encodeURIComponent("" + birthDate) + "&";
        if (rwLocationId === null)
            throw new Error("The parameter 'rwLocationId' cannot be null.");
        else if (rwLocationId !== undefined)
            url_ += "RwLocationId=" + encodeURIComponent("" + rwLocationId) + "&";
        if (mode === null)
            throw new Error("The parameter 'mode' cannot be null.");
        else if (mode !== undefined)
            url_ += "Mode=" + encodeURIComponent("" + mode) + "&";
        if (isPublicLink === null)
            throw new Error("The parameter 'isPublicLink' cannot be null.");
        else if (isPublicLink !== undefined)
            url_ += "IsPublicLink=" + encodeURIComponent("" + isPublicLink) + "&";
        if (linkType !== undefined && linkType !== null)
            url_ += "LinkType=" + encodeURIComponent("" + linkType) + "&";
        if (linkId !== undefined && linkId !== null)
            url_ += "LinkId=" + encodeURIComponent("" + linkId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: AxiosResponse): Promise<PatientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientDto.fromJS(resultData200);
            return Promise.resolve<PatientDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientDto>(null as any);
    }
}

export class FormAssignmentVm implements IFormAssignmentVm {
    isResponsibleParty?: boolean;
    responsiblePartyToDirectTo?: RwContact;
    patients?: RwContactWithFormAssignmentsDto[];

    constructor(data?: IFormAssignmentVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isResponsibleParty = _data["isResponsibleParty"];
            this.responsiblePartyToDirectTo = _data["responsiblePartyToDirectTo"] ? RwContact.fromJS(_data["responsiblePartyToDirectTo"]) : <any>undefined;
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(RwContactWithFormAssignmentsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormAssignmentVm {
        data = typeof data === 'object' ? data : {};
        let result = new FormAssignmentVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isResponsibleParty"] = this.isResponsibleParty;
        data["responsiblePartyToDirectTo"] = this.responsiblePartyToDirectTo ? this.responsiblePartyToDirectTo.toJSON() : <any>undefined;
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormAssignmentVm {
    isResponsibleParty?: boolean;
    responsiblePartyToDirectTo?: RwContact;
    patients?: RwContactWithFormAssignmentsDto[];
}

export class RwContact implements IRwContact {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    workPhone?: string | undefined;
    email?: string | undefined;
    dateOfBirth?: string | undefined;
    gender?: string | undefined;
    isResponsibleParty?: boolean;
    foreignId?: string | undefined;
    networkId?: number;
    nextAppointmentDate?: string | undefined;
    address?: RwContactAddress | undefined;
    location?: RwContactLocation | undefined;

    constructor(data?: IRwContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.cellPhone = _data["cellPhone"];
            this.homePhone = _data["homePhone"];
            this.workPhone = _data["workPhone"];
            this.email = _data["email"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.gender = _data["gender"];
            this.isResponsibleParty = _data["isResponsibleParty"];
            this.foreignId = _data["foreignId"];
            this.networkId = _data["networkId"];
            this.nextAppointmentDate = _data["nextAppointmentDate"];
            this.address = _data["address"] ? RwContactAddress.fromJS(_data["address"]) : <any>undefined;
            this.location = _data["location"] ? RwContactLocation.fromJS(_data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RwContact {
        data = typeof data === 'object' ? data : {};
        let result = new RwContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["cellPhone"] = this.cellPhone;
        data["homePhone"] = this.homePhone;
        data["workPhone"] = this.workPhone;
        data["email"] = this.email;
        data["dateOfBirth"] = this.dateOfBirth;
        data["gender"] = this.gender;
        data["isResponsibleParty"] = this.isResponsibleParty;
        data["foreignId"] = this.foreignId;
        data["networkId"] = this.networkId;
        data["nextAppointmentDate"] = this.nextAppointmentDate;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRwContact {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    workPhone?: string | undefined;
    email?: string | undefined;
    dateOfBirth?: string | undefined;
    gender?: string | undefined;
    isResponsibleParty?: boolean;
    foreignId?: string | undefined;
    networkId?: number;
    nextAppointmentDate?: string | undefined;
    address?: RwContactAddress | undefined;
    location?: RwContactLocation | undefined;
}

export class RwContactAddress implements IRwContactAddress {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IRwContactAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): RwContactAddress {
        data = typeof data === 'object' ? data : {};
        let result = new RwContactAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        return data;
    }
}

export interface IRwContactAddress {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
}

export class RwContactLocation implements IRwContactLocation {
    id?: number;
    name?: string | undefined;
    address?: RwContactAddress | undefined;

    constructor(data?: IRwContactLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"] ? RwContactAddress.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RwContactLocation {
        data = typeof data === 'object' ? data : {};
        let result = new RwContactLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRwContactLocation {
    id?: number;
    name?: string | undefined;
    address?: RwContactAddress | undefined;
}

export class RwContactWithFormAssignmentsDto extends RwContact implements IRwContactWithFormAssignmentsDto {
    needsConsent?: boolean;
    consentGiven?: boolean;
    consentGivenDisplay?: string;
    lastInvitedString?: string;
    lastInvited?: Date | undefined;
    formAssignments?: FormAssignmentDto[];

    constructor(data?: IRwContactWithFormAssignmentsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.needsConsent = _data["needsConsent"];
            this.consentGiven = _data["consentGiven"];
            this.consentGivenDisplay = _data["consentGivenDisplay"];
            this.lastInvitedString = _data["lastInvitedString"];
            this.lastInvited = _data["lastInvited"] ? new Date(_data["lastInvited"].toString()) : <any>undefined;
            if (Array.isArray(_data["formAssignments"])) {
                this.formAssignments = [] as any;
                for (let item of _data["formAssignments"])
                    this.formAssignments!.push(FormAssignmentDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RwContactWithFormAssignmentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RwContactWithFormAssignmentsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["needsConsent"] = this.needsConsent;
        data["consentGiven"] = this.consentGiven;
        data["consentGivenDisplay"] = this.consentGivenDisplay;
        data["lastInvitedString"] = this.lastInvitedString;
        data["lastInvited"] = this.lastInvited ? this.lastInvited.toISOString() : <any>undefined;
        if (Array.isArray(this.formAssignments)) {
            data["formAssignments"] = [];
            for (let item of this.formAssignments)
                data["formAssignments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRwContactWithFormAssignmentsDto extends IRwContact {
    needsConsent?: boolean;
    consentGiven?: boolean;
    consentGivenDisplay?: string;
    lastInvitedString?: string;
    lastInvited?: Date | undefined;
    formAssignments?: FormAssignmentDto[];
}

export class FormAssignmentDto implements IFormAssignmentDto {
    id?: string;
    patientIndex?: number;
    formName?: string;
    formId?: string;
    formType?: string;
    assigned?: Date;
    assignedString?: string;
    submitted?: Date | undefined;
    submittedBy?: FormSubmissionSubmittedBy | undefined;
    submissionId?: string | undefined;
    submittedString?: string;
    rwPatientId?: number | undefined;
    order?: number;
    appointmentId?: number | undefined;
    dueDate?: Date | undefined;
    hasPracticeSignature?: boolean;
    userProfileId?: number | undefined;
    formTemplateType?: FormTemplateType;

    constructor(data?: IFormAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patientIndex = _data["patientIndex"];
            this.formName = _data["formName"];
            this.formId = _data["formId"];
            this.formType = _data["formType"];
            this.assigned = _data["assigned"] ? new Date(_data["assigned"].toString()) : <any>undefined;
            this.assignedString = _data["assignedString"];
            this.submitted = _data["submitted"] ? new Date(_data["submitted"].toString()) : <any>undefined;
            this.submittedBy = _data["submittedBy"];
            this.submissionId = _data["submissionId"];
            this.submittedString = _data["submittedString"];
            this.rwPatientId = _data["rwPatientId"];
            this.order = _data["order"];
            this.appointmentId = _data["appointmentId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.hasPracticeSignature = _data["hasPracticeSignature"];
            this.userProfileId = _data["userProfileId"];
            this.formTemplateType = _data["formTemplateType"];
        }
    }

    static fromJS(data: any): FormAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patientIndex"] = this.patientIndex;
        data["formName"] = this.formName;
        data["formId"] = this.formId;
        data["formType"] = this.formType;
        data["assigned"] = this.assigned ? this.assigned.toISOString() : <any>undefined;
        data["assignedString"] = this.assignedString;
        data["submitted"] = this.submitted ? this.submitted.toISOString() : <any>undefined;
        data["submittedBy"] = this.submittedBy;
        data["submissionId"] = this.submissionId;
        data["submittedString"] = this.submittedString;
        data["rwPatientId"] = this.rwPatientId;
        data["order"] = this.order;
        data["appointmentId"] = this.appointmentId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["hasPracticeSignature"] = this.hasPracticeSignature;
        data["userProfileId"] = this.userProfileId;
        data["formTemplateType"] = this.formTemplateType;
        return data;
    }
}

export interface IFormAssignmentDto {
    id?: string;
    patientIndex?: number;
    formName?: string;
    formId?: string;
    formType?: string;
    assigned?: Date;
    assignedString?: string;
    submitted?: Date | undefined;
    submittedBy?: FormSubmissionSubmittedBy | undefined;
    submissionId?: string | undefined;
    submittedString?: string;
    rwPatientId?: number | undefined;
    order?: number;
    appointmentId?: number | undefined;
    dueDate?: Date | undefined;
    hasPracticeSignature?: boolean;
    userProfileId?: number | undefined;
    formTemplateType?: FormTemplateType;
}

export enum FormSubmissionSubmittedBy {
    Patient = 0,
    Practice = 1,
}

export enum FormTemplateType {
    None = 0,
    BuiltInPatientInformation = 1,
    BuiltInInsuranceInformation = 2,
    BuiltInHealthHistory = 3,
    BuiltInHealthHistoryEaglesoft = 4,
    BuiltInCovidScreening = 5,
    BuiltInHealthHistoryOpendental = 6,
    BuiltInHealthHistoryDxa = 7,
    BuiltInMissingPatientData = 8,
}

export class FormsAssignmentIndexVm implements IFormsAssignmentIndexVm {
    specialties?: KeyValuePairOfSpecialtyAndString[];

    constructor(data?: IFormsAssignmentIndexVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["specialties"])) {
                this.specialties = [] as any;
                for (let item of _data["specialties"])
                    this.specialties!.push(KeyValuePairOfSpecialtyAndString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormsAssignmentIndexVm {
        data = typeof data === 'object' ? data : {};
        let result = new FormsAssignmentIndexVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.specialties)) {
            data["specialties"] = [];
            for (let item of this.specialties)
                data["specialties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormsAssignmentIndexVm {
    specialties?: KeyValuePairOfSpecialtyAndString[];
}

export class KeyValuePairOfSpecialtyAndString implements IKeyValuePairOfSpecialtyAndString {
    key?: Specialty;
    value?: string | undefined;

    constructor(data?: IKeyValuePairOfSpecialtyAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfSpecialtyAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfSpecialtyAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfSpecialtyAndString {
    key?: Specialty;
    value?: string | undefined;
}

export enum Specialty {
    Anesthesia = 0,
    Cosmetic = 1,
    Dermatology = 2,
    EarNoseThroat = 3,
    Endo = 4,
    GD = 5,
    NonSpecialty = 6,
    OMS = 7,
    Ophthalmology = 8,
    Orthodontics = 9,
    Orthopedics = 10,
    Other = 11,
    Pediatric = 12,
    Periodontics = 13,
    PlasticSurgery = 14,
    Podiatry = 15,
    Prosthodontics = 16,
    Radiology = 17,
    Sedation = 18,
}

export class GetFormAssignmentsIndexVmQuery implements IGetFormAssignmentsIndexVmQuery {

    constructor(data?: IGetFormAssignmentsIndexVmQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetFormAssignmentsIndexVmQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormAssignmentsIndexVmQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetFormAssignmentsIndexVmQuery {
}

export class RwUserProfile implements IRwUserProfile {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    masterAccountId?: number;
    status?: string | undefined;

    constructor(data?: IRwUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.masterAccountId = _data["masterAccountId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RwUserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new RwUserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["masterAccountId"] = this.masterAccountId;
        data["status"] = this.status;
        return data;
    }
}

export interface IRwUserProfile {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    masterAccountId?: number;
    status?: string | undefined;
}

export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUnit {
}

export class CreateFormAssignmentCommand implements ICreateFormAssignmentCommand {
    formIds?: string[];
    packetIds?: string[];
    contact?: RwContactDto;
    client?: ClientApp | undefined;

    constructor(data?: ICreateFormAssignmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            if (Array.isArray(_data["packetIds"])) {
                this.packetIds = [] as any;
                for (let item of _data["packetIds"])
                    this.packetIds!.push(item);
            }
            this.contact = _data["contact"] ? RwContactDto.fromJS(_data["contact"]) : <any>undefined;
            this.client = _data["client"];
        }
    }

    static fromJS(data: any): CreateFormAssignmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormAssignmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        if (Array.isArray(this.packetIds)) {
            data["packetIds"] = [];
            for (let item of this.packetIds)
                data["packetIds"].push(item);
        }
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["client"] = this.client;
        return data;
    }
}

export interface ICreateFormAssignmentCommand {
    formIds?: string[];
    packetIds?: string[];
    contact?: RwContactDto;
    client?: ClientApp | undefined;
}

export class RwContactDto implements IRwContactDto {
    id?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    dateOfBirth?: string;
    locationId?: number;
    foreignId?: string;

    constructor(data?: IRwContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.locationId = _data["locationId"];
            this.foreignId = _data["foreignId"];
        }
    }

    static fromJS(data: any): RwContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new RwContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["dateOfBirth"] = this.dateOfBirth;
        data["locationId"] = this.locationId;
        data["foreignId"] = this.foreignId;
        return data;
    }
}

export interface IRwContactDto {
    id?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    dateOfBirth?: string;
    locationId?: number;
    foreignId?: string;
}

export enum ClientApp {
    Practice = 0,
    Patient = 1,
}

export class UpdatePatientConsentCommand implements IUpdatePatientConsentCommand {
    rwPatientId?: number;

    constructor(data?: IUpdatePatientConsentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rwPatientId = _data["rwPatientId"];
        }
    }

    static fromJS(data: any): UpdatePatientConsentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientConsentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rwPatientId"] = this.rwPatientId;
        return data;
    }
}

export interface IUpdatePatientConsentCommand {
    rwPatientId?: number;
}

export class UpdateFormAssignmentCommand implements IUpdateFormAssignmentCommand {
    formAssignmentId?: string;
    userProfileId?: number;

    constructor(data?: IUpdateFormAssignmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formAssignmentId = _data["formAssignmentId"];
            this.userProfileId = _data["userProfileId"];
        }
    }

    static fromJS(data: any): UpdateFormAssignmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormAssignmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formAssignmentId"] = this.formAssignmentId;
        data["userProfileId"] = this.userProfileId;
        return data;
    }
}

export interface IUpdateFormAssignmentCommand {
    formAssignmentId?: string;
    userProfileId?: number;
}

export class UpdateFormAssignmentOrderCommand implements IUpdateFormAssignmentOrderCommand {
    forms?: FormAssignmentDto[];
    patientId?: number;

    constructor(data?: IUpdateFormAssignmentOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(FormAssignmentDto.fromJS(item));
            }
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): UpdateFormAssignmentOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormAssignmentOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        data["patientId"] = this.patientId;
        return data;
    }
}

export interface IUpdateFormAssignmentOrderCommand {
    forms?: FormAssignmentDto[];
    patientId?: number;
}

export class SetDueDateOnFormAssignmentCommand implements ISetDueDateOnFormAssignmentCommand {
    formAssignmentId?: string;
    dueDate?: Date | undefined;
    appointmentId?: number | undefined;

    constructor(data?: ISetDueDateOnFormAssignmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formAssignmentId = _data["formAssignmentId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.appointmentId = _data["appointmentId"];
        }
    }

    static fromJS(data: any): SetDueDateOnFormAssignmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetDueDateOnFormAssignmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formAssignmentId"] = this.formAssignmentId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["appointmentId"] = this.appointmentId;
        return data;
    }
}

export interface ISetDueDateOnFormAssignmentCommand {
    formAssignmentId?: string;
    dueDate?: Date | undefined;
    appointmentId?: number | undefined;
}

export class DeleteFormAssignmentCommand implements IDeleteFormAssignmentCommand {
    id?: string;

    constructor(data?: IDeleteFormAssignmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteFormAssignmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFormAssignmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteFormAssignmentCommand {
    id?: string;
}

export class DeleteAllFormAssignmentsForPatientCommand implements IDeleteAllFormAssignmentsForPatientCommand {
    rwPatientId?: number;

    constructor(data?: IDeleteAllFormAssignmentsForPatientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rwPatientId = _data["rwPatientId"];
        }
    }

    static fromJS(data: any): DeleteAllFormAssignmentsForPatientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAllFormAssignmentsForPatientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rwPatientId"] = this.rwPatientId;
        return data;
    }
}

export interface IDeleteAllFormAssignmentsForPatientCommand {
    rwPatientId?: number;
}

export class PmsSystemVm implements IPmsSystemVm {
    name?: string;
    formFields?: FormFieldDto[];
    allergyFormFields?: FormFieldDto[];
    diseaseFormFields?: FormFieldDto[];

    constructor(data?: IPmsSystemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["formFields"])) {
                this.formFields = [] as any;
                for (let item of _data["formFields"])
                    this.formFields!.push(FormFieldDto.fromJS(item));
            }
            if (Array.isArray(_data["allergyFormFields"])) {
                this.allergyFormFields = [] as any;
                for (let item of _data["allergyFormFields"])
                    this.allergyFormFields!.push(FormFieldDto.fromJS(item));
            }
            if (Array.isArray(_data["diseaseFormFields"])) {
                this.diseaseFormFields = [] as any;
                for (let item of _data["diseaseFormFields"])
                    this.diseaseFormFields!.push(FormFieldDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PmsSystemVm {
        data = typeof data === 'object' ? data : {};
        let result = new PmsSystemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.formFields)) {
            data["formFields"] = [];
            for (let item of this.formFields)
                data["formFields"].push(item.toJSON());
        }
        if (Array.isArray(this.allergyFormFields)) {
            data["allergyFormFields"] = [];
            for (let item of this.allergyFormFields)
                data["allergyFormFields"].push(item.toJSON());
        }
        if (Array.isArray(this.diseaseFormFields)) {
            data["diseaseFormFields"] = [];
            for (let item of this.diseaseFormFields)
                data["diseaseFormFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPmsSystemVm {
    name?: string;
    formFields?: FormFieldDto[];
    allergyFormFields?: FormFieldDto[];
    diseaseFormFields?: FormFieldDto[];
}

export class FormFieldDto implements IFormFieldDto {
    id?: number;
    name?: string;
    display?: string;
    autoComplete?: string;
    htmlType?: string;
    dataType?: string;
    externalId?: FormTwoExternalIdWithStringItemType | undefined;
    formFieldOptions?: FormFieldOptionDto[] | undefined;

    constructor(data?: IFormFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.display = _data["display"];
            this.autoComplete = _data["autoComplete"];
            this.htmlType = _data["htmlType"];
            this.dataType = _data["dataType"];
            this.externalId = _data["externalId"] ? FormTwoExternalIdWithStringItemType.fromJS(_data["externalId"]) : <any>undefined;
            if (Array.isArray(_data["formFieldOptions"])) {
                this.formFieldOptions = [] as any;
                for (let item of _data["formFieldOptions"])
                    this.formFieldOptions!.push(FormFieldOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["display"] = this.display;
        data["autoComplete"] = this.autoComplete;
        data["htmlType"] = this.htmlType;
        data["dataType"] = this.dataType;
        data["externalId"] = this.externalId ? this.externalId.toJSON() : <any>undefined;
        if (Array.isArray(this.formFieldOptions)) {
            data["formFieldOptions"] = [];
            for (let item of this.formFieldOptions)
                data["formFieldOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormFieldDto {
    id?: number;
    name?: string;
    display?: string;
    autoComplete?: string;
    htmlType?: string;
    dataType?: string;
    externalId?: FormTwoExternalIdWithStringItemType | undefined;
    formFieldOptions?: FormFieldOptionDto[] | undefined;
}

export class BaseFormTwoExternalId implements IBaseFormTwoExternalId {
    externalId?: string | undefined;

    constructor(data?: IBaseFormTwoExternalId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): BaseFormTwoExternalId {
        data = typeof data === 'object' ? data : {};
        let result = new BaseFormTwoExternalId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IBaseFormTwoExternalId {
    externalId?: string | undefined;
}

export class FormTwoExternalIdWithStringItemType extends BaseFormTwoExternalId implements IFormTwoExternalIdWithStringItemType {
    externalItemType?: string | undefined;

    constructor(data?: IFormTwoExternalIdWithStringItemType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.externalItemType = _data["externalItemType"];
        }
    }

    static override fromJS(data: any): FormTwoExternalIdWithStringItemType {
        data = typeof data === 'object' ? data : {};
        let result = new FormTwoExternalIdWithStringItemType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalItemType"] = this.externalItemType;
        super.toJSON(data);
        return data;
    }
}

export interface IFormTwoExternalIdWithStringItemType extends IBaseFormTwoExternalId {
    externalItemType?: string | undefined;
}

export class FormFieldOptionDto implements IFormFieldOptionDto {
    id?: number;
    text?: string;
    value?: string;
    enabled?: boolean;

    constructor(data?: IFormFieldOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.value = _data["value"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): FormFieldOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["value"] = this.value;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IFormFieldOptionDto {
    id?: number;
    text?: string;
    value?: string;
    enabled?: boolean;
}

export class CreateFormFieldCommand implements ICreateFormFieldCommand {
    formFields?: FormFieldDto[];

    constructor(data?: ICreateFormFieldCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formFields"])) {
                this.formFields = [] as any;
                for (let item of _data["formFields"])
                    this.formFields!.push(FormFieldDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateFormFieldCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormFieldCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formFields)) {
            data["formFields"] = [];
            for (let item of this.formFields)
                data["formFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateFormFieldCommand {
    formFields?: FormFieldDto[];
}

export class FormPacketDto implements IFormPacketDto {
    id?: string;
    name?: string;
    created?: Date;
    lastModified?: Date | undefined;
    lastModifiedBy?: string;
    lastModifiedString?: string;
    isPublic?: boolean;
    locationIds?: number[];
    forms?: PacketFormsDto[];
    specialties?: KeyValuePairOfSpecialtyAndString[];
    canManagePackets?: boolean;

    constructor(data?: IFormPacketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedString = _data["lastModifiedString"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(PacketFormsDto.fromJS(item));
            }
            if (Array.isArray(_data["specialties"])) {
                this.specialties = [] as any;
                for (let item of _data["specialties"])
                    this.specialties!.push(KeyValuePairOfSpecialtyAndString.fromJS(item));
            }
            this.canManagePackets = _data["canManagePackets"];
        }
    }

    static fromJS(data: any): FormPacketDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormPacketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedString"] = this.lastModifiedString;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        if (Array.isArray(this.specialties)) {
            data["specialties"] = [];
            for (let item of this.specialties)
                data["specialties"].push(item.toJSON());
        }
        data["canManagePackets"] = this.canManagePackets;
        return data;
    }
}

export interface IFormPacketDto {
    id?: string;
    name?: string;
    created?: Date;
    lastModified?: Date | undefined;
    lastModifiedBy?: string;
    lastModifiedString?: string;
    isPublic?: boolean;
    locationIds?: number[];
    forms?: PacketFormsDto[];
    specialties?: KeyValuePairOfSpecialtyAndString[];
    canManagePackets?: boolean;
}

export class PacketFormsDto implements IPacketFormsDto {
    formId?: string;
    formName?: string;
    order?: number;
    formIndex?: number;

    constructor(data?: IPacketFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.order = _data["order"];
            this.formIndex = _data["formIndex"];
        }
    }

    static fromJS(data: any): PacketFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PacketFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["order"] = this.order;
        data["formIndex"] = this.formIndex;
        return data;
    }
}

export interface IPacketFormsDto {
    formId?: string;
    formName?: string;
    order?: number;
    formIndex?: number;
}

export class CreateFormPacketCommand implements ICreateFormPacketCommand {
    name?: string;
    formIds?: string[];
    locationIds?: number[];
    isPublic?: boolean;

    constructor(data?: ICreateFormPacketCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): CreateFormPacketCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormPacketCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["isPublic"] = this.isPublic;
        return data;
    }
}

export interface ICreateFormPacketCommand {
    name?: string;
    formIds?: string[];
    locationIds?: number[];
    isPublic?: boolean;
}

export class EnsurePublicPacketForLocationCommand implements IEnsurePublicPacketForLocationCommand {
    accountId?: number;
    locationId?: number;

    constructor(data?: IEnsurePublicPacketForLocationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): EnsurePublicPacketForLocationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EnsurePublicPacketForLocationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface IEnsurePublicPacketForLocationCommand {
    accountId?: number;
    locationId?: number;
}

export class FormPacketsVm implements IFormPacketsVm {
    count?: number;
    packets?: FormPacketListDto[];

    constructor(data?: IFormPacketsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["packets"])) {
                this.packets = [] as any;
                for (let item of _data["packets"])
                    this.packets!.push(FormPacketListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormPacketsVm {
        data = typeof data === 'object' ? data : {};
        let result = new FormPacketsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.packets)) {
            data["packets"] = [];
            for (let item of this.packets)
                data["packets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormPacketsVm {
    count?: number;
    packets?: FormPacketListDto[];
}

export class FormPacketListDto implements IFormPacketListDto {
    id?: string;
    name?: string;
    created?: Date;
    formCount?: number;
    locationIds?: number[];
    lastModifiedBy?: string;
    lastModifiedString?: string;
    lastModified?: Date | undefined;
    formNames?: string;
    isPublic?: boolean;

    constructor(data?: IFormPacketListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.formCount = _data["formCount"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedString = _data["lastModifiedString"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.formNames = _data["formNames"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): FormPacketListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormPacketListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["formCount"] = this.formCount;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedString"] = this.lastModifiedString;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["formNames"] = this.formNames;
        data["isPublic"] = this.isPublic;
        return data;
    }
}

export interface IFormPacketListDto {
    id?: string;
    name?: string;
    created?: Date;
    formCount?: number;
    locationIds?: number[];
    lastModifiedBy?: string;
    lastModifiedString?: string;
    lastModified?: Date | undefined;
    formNames?: string;
    isPublic?: boolean;
}

export class ShortUrlDto implements IShortUrlDto {
    rwLocationId?: number;
    shortUrl?: string;

    constructor(data?: IShortUrlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rwLocationId = _data["rwLocationId"];
            this.shortUrl = _data["shortUrl"];
        }
    }

    static fromJS(data: any): ShortUrlDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShortUrlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rwLocationId"] = this.rwLocationId;
        data["shortUrl"] = this.shortUrl;
        return data;
    }
}

export interface IShortUrlDto {
    rwLocationId?: number;
    shortUrl?: string;
}

export class UpdateFormPacketCommand implements IUpdateFormPacketCommand {
    id?: string;
    name?: string;
    isPublic?: boolean;
    locationIds?: number[];
    forms?: PacketFormsDto[];

    constructor(data?: IUpdateFormPacketCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(PacketFormsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateFormPacketCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormPacketCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateFormPacketCommand {
    id?: string;
    name?: string;
    isPublic?: boolean;
    locationIds?: number[];
    forms?: PacketFormsDto[];
}

export class CreatePacketLinkCommand implements ICreatePacketLinkCommand {
    id?: string;
    locationId?: number;

    constructor(data?: ICreatePacketLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): CreatePacketLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePacketLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface ICreatePacketLinkCommand {
    id?: string;
    locationId?: number;
}

export class FormPacketsIndexVm implements IFormPacketsIndexVm {
    noCustomPackets?: boolean;
    canManagePackets?: boolean;

    constructor(data?: IFormPacketsIndexVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noCustomPackets = _data["noCustomPackets"];
            this.canManagePackets = _data["canManagePackets"];
        }
    }

    static fromJS(data: any): FormPacketsIndexVm {
        data = typeof data === 'object' ? data : {};
        let result = new FormPacketsIndexVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noCustomPackets"] = this.noCustomPackets;
        data["canManagePackets"] = this.canManagePackets;
        return data;
    }
}

export interface IFormPacketsIndexVm {
    noCustomPackets?: boolean;
    canManagePackets?: boolean;
}

export class FormPacketWithUrlVm implements IFormPacketWithUrlVm {
    id?: string;
    name?: string;
    link?: string;

    constructor(data?: IFormPacketWithUrlVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): FormPacketWithUrlVm {
        data = typeof data === 'object' ? data : {};
        let result = new FormPacketWithUrlVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["link"] = this.link;
        return data;
    }
}

export interface IFormPacketWithUrlVm {
    id?: string;
    name?: string;
    link?: string;
}

export class FormVm implements IFormVm {
    id?: string;
    formDataId?: string;
    name?: string;
    formType?: FormType;
    accountId?: number;
    lastModified?: Date | undefined;
    lastModifiedBy?: string;
    lastModifiedString?: string;
    locationIds?: number[];
    specialties?: KeyValuePairOfSpecialtyAndString[];
    specialty?: Specialty;
    isInBaseAccount?: boolean;
    autoSync?: boolean;
    autoSyncNotAllowed?: boolean;
    importedFromPms?: boolean;
    formPmsDtos?: PmsDataDefaultDto[];
    isStarterClient?: boolean;
    googleMapApiKey?: string;
    isHidden?: boolean;
    canEditForm?: boolean;

    constructor(data?: IFormVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formDataId = _data["formDataId"];
            this.name = _data["name"];
            this.formType = _data["formType"];
            this.accountId = _data["accountId"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedString = _data["lastModifiedString"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            if (Array.isArray(_data["specialties"])) {
                this.specialties = [] as any;
                for (let item of _data["specialties"])
                    this.specialties!.push(KeyValuePairOfSpecialtyAndString.fromJS(item));
            }
            this.specialty = _data["specialty"];
            this.isInBaseAccount = _data["isInBaseAccount"];
            this.autoSync = _data["autoSync"];
            this.autoSyncNotAllowed = _data["autoSyncNotAllowed"];
            this.importedFromPms = _data["importedFromPms"];
            if (Array.isArray(_data["formPmsDtos"])) {
                this.formPmsDtos = [] as any;
                for (let item of _data["formPmsDtos"])
                    this.formPmsDtos!.push(PmsDataDefaultDto.fromJS(item));
            }
            this.isStarterClient = _data["isStarterClient"];
            this.googleMapApiKey = _data["googleMapApiKey"];
            this.isHidden = _data["isHidden"];
            this.canEditForm = _data["canEditForm"];
        }
    }

    static fromJS(data: any): FormVm {
        data = typeof data === 'object' ? data : {};
        let result = new FormVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formDataId"] = this.formDataId;
        data["name"] = this.name;
        data["formType"] = this.formType;
        data["accountId"] = this.accountId;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedString"] = this.lastModifiedString;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.specialties)) {
            data["specialties"] = [];
            for (let item of this.specialties)
                data["specialties"].push(item.toJSON());
        }
        data["specialty"] = this.specialty;
        data["isInBaseAccount"] = this.isInBaseAccount;
        data["autoSync"] = this.autoSync;
        data["autoSyncNotAllowed"] = this.autoSyncNotAllowed;
        data["importedFromPms"] = this.importedFromPms;
        if (Array.isArray(this.formPmsDtos)) {
            data["formPmsDtos"] = [];
            for (let item of this.formPmsDtos)
                data["formPmsDtos"].push(item.toJSON());
        }
        data["isStarterClient"] = this.isStarterClient;
        data["googleMapApiKey"] = this.googleMapApiKey;
        data["isHidden"] = this.isHidden;
        data["canEditForm"] = this.canEditForm;
        return data;
    }
}

export interface IFormVm {
    id?: string;
    formDataId?: string;
    name?: string;
    formType?: FormType;
    accountId?: number;
    lastModified?: Date | undefined;
    lastModifiedBy?: string;
    lastModifiedString?: string;
    locationIds?: number[];
    specialties?: KeyValuePairOfSpecialtyAndString[];
    specialty?: Specialty;
    isInBaseAccount?: boolean;
    autoSync?: boolean;
    autoSyncNotAllowed?: boolean;
    importedFromPms?: boolean;
    formPmsDtos?: PmsDataDefaultDto[];
    isStarterClient?: boolean;
    googleMapApiKey?: string;
    isHidden?: boolean;
    canEditForm?: boolean;
}

export enum FormType {
    Registration = 0,
    Consent = 2,
    Miscellaneous = 3,
    Uploaded = 4,
    MissingPatientData = 5,
}

export class PmsDataDefaultDto implements IPmsDataDefaultDto {
    rwLocationId?: number;
    defaultRwPmsProviderForeignId?: string | undefined;
    defaultRwPmsDocumentCategoryForeignId?: string | undefined;
    externalSystemType?: string | undefined;

    constructor(data?: IPmsDataDefaultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rwLocationId = _data["rwLocationId"];
            this.defaultRwPmsProviderForeignId = _data["defaultRwPmsProviderForeignId"];
            this.defaultRwPmsDocumentCategoryForeignId = _data["defaultRwPmsDocumentCategoryForeignId"];
            this.externalSystemType = _data["externalSystemType"];
        }
    }

    static fromJS(data: any): PmsDataDefaultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PmsDataDefaultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rwLocationId"] = this.rwLocationId;
        data["defaultRwPmsProviderForeignId"] = this.defaultRwPmsProviderForeignId;
        data["defaultRwPmsDocumentCategoryForeignId"] = this.defaultRwPmsDocumentCategoryForeignId;
        data["externalSystemType"] = this.externalSystemType;
        return data;
    }
}

export interface IPmsDataDefaultDto {
    rwLocationId?: number;
    defaultRwPmsProviderForeignId?: string | undefined;
    defaultRwPmsDocumentCategoryForeignId?: string | undefined;
    externalSystemType?: string | undefined;
}

export class OldRwFormDto implements IOldRwFormDto {
    id?: number;
    name?: string;
    data?: string;

    constructor(data?: IOldRwFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): OldRwFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new OldRwFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["data"] = this.data;
        return data;
    }
}

export interface IOldRwFormDto {
    id?: number;
    name?: string;
    data?: string;
}

export class FormWithUriDto implements IFormWithUriDto {
    id?: string;
    formDataId?: string;
    name?: string;
    formType?: FormType;
    created?: Date;
    importedFromPms?: boolean;
    googleMapApiKey?: string;
    azureBlobSasUri?: string;

    constructor(data?: IFormWithUriDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formDataId = _data["formDataId"];
            this.name = _data["name"];
            this.formType = _data["formType"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.importedFromPms = _data["importedFromPms"];
            this.googleMapApiKey = _data["googleMapApiKey"];
            this.azureBlobSasUri = _data["azureBlobSasUri"];
        }
    }

    static fromJS(data: any): FormWithUriDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormWithUriDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formDataId"] = this.formDataId;
        data["name"] = this.name;
        data["formType"] = this.formType;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["importedFromPms"] = this.importedFromPms;
        data["googleMapApiKey"] = this.googleMapApiKey;
        data["azureBlobSasUri"] = this.azureBlobSasUri;
        return data;
    }
}

export interface IFormWithUriDto {
    id?: string;
    formDataId?: string;
    name?: string;
    formType?: FormType;
    created?: Date;
    importedFromPms?: boolean;
    googleMapApiKey?: string;
    azureBlobSasUri?: string;
}

export class OldRwFormsVm implements IOldRwFormsVm {
    count?: number;
    forms?: OldRwFormListDto[];

    constructor(data?: IOldRwFormsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(OldRwFormListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OldRwFormsVm {
        data = typeof data === 'object' ? data : {};
        let result = new OldRwFormsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOldRwFormsVm {
    count?: number;
    forms?: OldRwFormListDto[];
}

export class OldRwFormListDto implements IOldRwFormListDto {
    id?: number;
    name?: string;
    locations?: number[];

    constructor(data?: IOldRwFormListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(item);
            }
        }
    }

    static fromJS(data: any): OldRwFormListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OldRwFormListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item);
        }
        return data;
    }
}

export interface IOldRwFormListDto {
    id?: number;
    name?: string;
    locations?: number[];
}

export class FormsVm implements IFormsVm {
    count?: number;
    forms?: FormListDto[];

    constructor(data?: IFormsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(FormListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormsVm {
        data = typeof data === 'object' ? data : {};
        let result = new FormsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormsVm {
    count?: number;
    forms?: FormListDto[];
}

export class FormListDto implements IFormListDto {
    index?: number;
    id?: string;
    name?: string;
    formType?: FormType;
    formTypeName?: string;
    specialty?: string;
    lastModified?: Date | undefined;
    lastModifiedBy?: string;
    lastModifiedString?: string;
    locationIds?: number[];
    autoSync?: boolean;

    constructor(data?: IFormListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.formType = _data["formType"];
            this.formTypeName = _data["formTypeName"];
            this.specialty = _data["specialty"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedString = _data["lastModifiedString"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.autoSync = _data["autoSync"];
        }
    }

    static fromJS(data: any): FormListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["id"] = this.id;
        data["name"] = this.name;
        data["formType"] = this.formType;
        data["formTypeName"] = this.formTypeName;
        data["specialty"] = this.specialty;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedString"] = this.lastModifiedString;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["autoSync"] = this.autoSync;
        return data;
    }
}

export interface IFormListDto {
    index?: number;
    id?: string;
    name?: string;
    formType?: FormType;
    formTypeName?: string;
    specialty?: string;
    lastModified?: Date | undefined;
    lastModifiedBy?: string;
    lastModifiedString?: string;
    locationIds?: number[];
    autoSync?: boolean;
}

export enum FormListType {
    All = 0,
    Custom = 1,
    Imported = 2,
}

export class FormsIndexVm implements IFormsIndexVm {
    noCustomForms?: boolean;
    specialties?: KeyValuePairOfSpecialtyAndString[];
    isInBaseAccount?: boolean;
    isStarterClient?: boolean;
    canCreateForm?: boolean;
    canEditForm?: boolean;
    canDeleteForm?: boolean;

    constructor(data?: IFormsIndexVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noCustomForms = _data["noCustomForms"];
            if (Array.isArray(_data["specialties"])) {
                this.specialties = [] as any;
                for (let item of _data["specialties"])
                    this.specialties!.push(KeyValuePairOfSpecialtyAndString.fromJS(item));
            }
            this.isInBaseAccount = _data["isInBaseAccount"];
            this.isStarterClient = _data["isStarterClient"];
            this.canCreateForm = _data["canCreateForm"];
            this.canEditForm = _data["canEditForm"];
            this.canDeleteForm = _data["canDeleteForm"];
        }
    }

    static fromJS(data: any): FormsIndexVm {
        data = typeof data === 'object' ? data : {};
        let result = new FormsIndexVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noCustomForms"] = this.noCustomForms;
        if (Array.isArray(this.specialties)) {
            data["specialties"] = [];
            for (let item of this.specialties)
                data["specialties"].push(item.toJSON());
        }
        data["isInBaseAccount"] = this.isInBaseAccount;
        data["isStarterClient"] = this.isStarterClient;
        data["canCreateForm"] = this.canCreateForm;
        data["canEditForm"] = this.canEditForm;
        data["canDeleteForm"] = this.canDeleteForm;
        return data;
    }
}

export interface IFormsIndexVm {
    noCustomForms?: boolean;
    specialties?: KeyValuePairOfSpecialtyAndString[];
    isInBaseAccount?: boolean;
    isStarterClient?: boolean;
    canCreateForm?: boolean;
    canEditForm?: boolean;
    canDeleteForm?: boolean;
}

export class ImportVm implements IImportVm {
    specialties?: KeyValuePairOfSpecialtyAndString[];

    constructor(data?: IImportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["specialties"])) {
                this.specialties = [] as any;
                for (let item of _data["specialties"])
                    this.specialties!.push(KeyValuePairOfSpecialtyAndString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportVm {
        data = typeof data === 'object' ? data : {};
        let result = new ImportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.specialties)) {
            data["specialties"] = [];
            for (let item of this.specialties)
                data["specialties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImportVm {
    specialties?: KeyValuePairOfSpecialtyAndString[];
}

export class GetImportVmQuery implements IGetImportVmQuery {

    constructor(data?: IGetImportVmQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetImportVmQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetImportVmQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetImportVmQuery {
}

export class FormTwo implements IFormTwo {
    layout?: FormTwoRow[] | undefined;
    components?: { [key: string]: FormTwoComponent; } | undefined;
    rules?: Rule[] | undefined;
    pdf?: string | undefined;
    pdfPagesMetadata?: FormTwoPdfPageMetaData[] | undefined;
    displayLabels?: boolean | undefined;

    constructor(data?: IFormTwo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["layout"])) {
                this.layout = [] as any;
                for (let item of _data["layout"])
                    this.layout!.push(FormTwoRow.fromJS(item));
            }
            if (_data["components"]) {
                this.components = {} as any;
                for (let key in _data["components"]) {
                    if (_data["components"].hasOwnProperty(key))
                        (<any>this.components)![key] = _data["components"][key] ? FormTwoComponent.fromJS(_data["components"][key]) : new FormTwoComponent();
                }
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(Rule.fromJS(item));
            }
            this.pdf = _data["pdf"];
            if (Array.isArray(_data["pdfPagesMetadata"])) {
                this.pdfPagesMetadata = [] as any;
                for (let item of _data["pdfPagesMetadata"])
                    this.pdfPagesMetadata!.push(FormTwoPdfPageMetaData.fromJS(item));
            }
            this.displayLabels = _data["displayLabels"];
        }
    }

    static fromJS(data: any): FormTwo {
        data = typeof data === 'object' ? data : {};
        let result = new FormTwo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.layout)) {
            data["layout"] = [];
            for (let item of this.layout)
                data["layout"].push(item.toJSON());
        }
        if (this.components) {
            data["components"] = {};
            for (let key in this.components) {
                if (this.components.hasOwnProperty(key))
                    (<any>data["components"])[key] = this.components[key] ? this.components[key].toJSON() : <any>undefined;
            }
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["pdf"] = this.pdf;
        if (Array.isArray(this.pdfPagesMetadata)) {
            data["pdfPagesMetadata"] = [];
            for (let item of this.pdfPagesMetadata)
                data["pdfPagesMetadata"].push(item.toJSON());
        }
        data["displayLabels"] = this.displayLabels;
        return data;
    }
}

export interface IFormTwo {
    layout?: FormTwoRow[] | undefined;
    components?: { [key: string]: FormTwoComponent; } | undefined;
    rules?: Rule[] | undefined;
    pdf?: string | undefined;
    pdfPagesMetadata?: FormTwoPdfPageMetaData[] | undefined;
    displayLabels?: boolean | undefined;
}

export class FormTwoRow implements IFormTwoRow {
    type?: string | undefined;
    id?: string | undefined;
    children?: FormTwoColumn[] | undefined;

    constructor(data?: IFormTwoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(FormTwoColumn.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormTwoRow {
        data = typeof data === 'object' ? data : {};
        let result = new FormTwoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormTwoRow {
    type?: string | undefined;
    id?: string | undefined;
    children?: FormTwoColumn[] | undefined;
}

export class FormTwoColumn implements IFormTwoColumn {
    type?: string | undefined;
    id?: string | undefined;
    children?: FormTwoLayoutComponent[] | undefined;

    constructor(data?: IFormTwoColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(FormTwoLayoutComponent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormTwoColumn {
        data = typeof data === 'object' ? data : {};
        let result = new FormTwoColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormTwoColumn {
    type?: string | undefined;
    id?: string | undefined;
    children?: FormTwoLayoutComponent[] | undefined;
}

export class FormTwoLayoutComponent implements IFormTwoLayoutComponent {
    type?: string | undefined;
    id?: string | undefined;

    constructor(data?: IFormTwoLayoutComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FormTwoLayoutComponent {
        data = typeof data === 'object' ? data : {};
        let result = new FormTwoLayoutComponent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface IFormTwoLayoutComponent {
    type?: string | undefined;
    id?: string | undefined;
}

export class FormTwoComponent implements IFormTwoComponent {
    type?: string | undefined;
    typeDisplay?: string | undefined;
    key?: string | undefined;
    canReadOnly?: boolean;
    name?: string | undefined;
    label?: string | undefined;
    field_Name?: string | undefined;
    mask?: string | undefined;
    id?: string | undefined;
    element?: string | undefined;
    required?: boolean;
    value?: string | undefined;
    options?: FormTwoComponentOption[] | undefined;
    optionsSource?: OptionsSource;
    explaination?: boolean;
    childComponents?: { [key: string]: FormTwoComponent; } | undefined;
    canHaveAnswer?: boolean;
    content?: string | undefined;
    static?: boolean;
    externalId?: FormTwoExternalId | undefined;
    fieldId?: number | undefined;

    constructor(data?: IFormTwoComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.typeDisplay = _data["typeDisplay"];
            this.key = _data["key"];
            this.canReadOnly = _data["canReadOnly"];
            this.name = _data["name"];
            this.label = _data["label"];
            this.field_Name = _data["field_Name"];
            this.mask = _data["mask"];
            this.id = _data["id"];
            this.element = _data["element"];
            this.required = _data["required"];
            this.value = _data["value"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(FormTwoComponentOption.fromJS(item));
            }
            this.optionsSource = _data["optionsSource"];
            this.explaination = _data["explaination"];
            if (_data["childComponents"]) {
                this.childComponents = {} as any;
                for (let key in _data["childComponents"]) {
                    if (_data["childComponents"].hasOwnProperty(key))
                        (<any>this.childComponents)![key] = _data["childComponents"][key] ? FormTwoComponent.fromJS(_data["childComponents"][key]) : new FormTwoComponent();
                }
            }
            this.canHaveAnswer = _data["canHaveAnswer"];
            this.content = _data["content"];
            this.static = _data["static"];
            this.externalId = _data["externalId"] ? FormTwoExternalId.fromJS(_data["externalId"]) : <any>undefined;
            this.fieldId = _data["fieldId"];
        }
    }

    static fromJS(data: any): FormTwoComponent {
        data = typeof data === 'object' ? data : {};
        let result = new FormTwoComponent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["typeDisplay"] = this.typeDisplay;
        data["key"] = this.key;
        data["canReadOnly"] = this.canReadOnly;
        data["name"] = this.name;
        data["label"] = this.label;
        data["field_Name"] = this.field_Name;
        data["mask"] = this.mask;
        data["id"] = this.id;
        data["element"] = this.element;
        data["required"] = this.required;
        data["value"] = this.value;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["optionsSource"] = this.optionsSource;
        data["explaination"] = this.explaination;
        if (this.childComponents) {
            data["childComponents"] = {};
            for (let key in this.childComponents) {
                if (this.childComponents.hasOwnProperty(key))
                    (<any>data["childComponents"])[key] = this.childComponents[key] ? this.childComponents[key].toJSON() : <any>undefined;
            }
        }
        data["canHaveAnswer"] = this.canHaveAnswer;
        data["content"] = this.content;
        data["static"] = this.static;
        data["externalId"] = this.externalId ? this.externalId.toJSON() : <any>undefined;
        data["fieldId"] = this.fieldId;
        return data;
    }
}

export interface IFormTwoComponent {
    type?: string | undefined;
    typeDisplay?: string | undefined;
    key?: string | undefined;
    canReadOnly?: boolean;
    name?: string | undefined;
    label?: string | undefined;
    field_Name?: string | undefined;
    mask?: string | undefined;
    id?: string | undefined;
    element?: string | undefined;
    required?: boolean;
    value?: string | undefined;
    options?: FormTwoComponentOption[] | undefined;
    optionsSource?: OptionsSource;
    explaination?: boolean;
    childComponents?: { [key: string]: FormTwoComponent; } | undefined;
    canHaveAnswer?: boolean;
    content?: string | undefined;
    static?: boolean;
    externalId?: FormTwoExternalId | undefined;
    fieldId?: number | undefined;
}

export class FormTwoComponentOption implements IFormTwoComponentOption {
    value?: string | undefined;
    text?: string | undefined;
    key?: string | undefined;
    externalId?: FormTwoExternalId | undefined;

    constructor(data?: IFormTwoComponentOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.text = _data["text"];
            this.key = _data["key"];
            this.externalId = _data["externalId"] ? FormTwoExternalId.fromJS(_data["externalId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormTwoComponentOption {
        data = typeof data === 'object' ? data : {};
        let result = new FormTwoComponentOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text;
        data["key"] = this.key;
        data["externalId"] = this.externalId ? this.externalId.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFormTwoComponentOption {
    value?: string | undefined;
    text?: string | undefined;
    key?: string | undefined;
    externalId?: FormTwoExternalId | undefined;
}

export class FormTwoExternalId extends BaseFormTwoExternalId implements IFormTwoExternalId {
    formItemExternalId?: string | undefined;
    externalItemType?: SingleSourceFormItemType;

    constructor(data?: IFormTwoExternalId) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.formItemExternalId = _data["formItemExternalId"];
            this.externalItemType = _data["externalItemType"];
        }
    }

    static override fromJS(data: any): FormTwoExternalId {
        data = typeof data === 'object' ? data : {};
        let result = new FormTwoExternalId();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formItemExternalId"] = this.formItemExternalId;
        data["externalItemType"] = this.externalItemType;
        super.toJSON(data);
        return data;
    }
}

export interface IFormTwoExternalId extends IBaseFormTwoExternalId {
    formItemExternalId?: string | undefined;
    externalItemType?: SingleSourceFormItemType;
}

export enum SingleSourceFormItemType {
    Section = 0,
    TextQuestion = 10,
    CheckboxQuestion = 20,
    RadioButtonQuestion = 30,
    DropDownQuestion = 40,
    Initials = 50,
    Signature = 60,
    SignatureRelation = 70,
    Comment = 80,
    Paragraph = 90,
    DateQuestion = 100,
}

export enum OptionsSource {
    MANUAL = 0,
    INSURANCEPROVIDER = 1,
}

export class Rule implements IRule {
    name?: string | undefined;
    conditions?: AnyCondition | undefined;
    event?: Event | undefined;

    constructor(data?: IRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.conditions = _data["conditions"] ? AnyCondition.fromJS(_data["conditions"]) : <any>undefined;
            this.event = _data["event"] ? Event.fromJS(_data["event"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Rule {
        data = typeof data === 'object' ? data : {};
        let result = new Rule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["conditions"] = this.conditions ? this.conditions.toJSON() : <any>undefined;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRule {
    name?: string | undefined;
    conditions?: AnyCondition | undefined;
    event?: Event | undefined;
}

export class AnyCondition implements IAnyCondition {
    any?: AllCondition[] | undefined;

    constructor(data?: IAnyCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["any"])) {
                this.any = [] as any;
                for (let item of _data["any"])
                    this.any!.push(AllCondition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnyCondition {
        data = typeof data === 'object' ? data : {};
        let result = new AnyCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.any)) {
            data["any"] = [];
            for (let item of this.any)
                data["any"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnyCondition {
    any?: AllCondition[] | undefined;
}

export class AllCondition implements IAllCondition {
    all?: Condition[] | undefined;

    constructor(data?: IAllCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["all"])) {
                this.all = [] as any;
                for (let item of _data["all"])
                    this.all!.push(Condition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllCondition {
        data = typeof data === 'object' ? data : {};
        let result = new AllCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.all)) {
            data["all"] = [];
            for (let item of this.all)
                data["all"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllCondition {
    all?: Condition[] | undefined;
}

export class Condition implements ICondition {
    fact?: string | undefined;
    operator?: string | undefined;
    value?: string | undefined;

    constructor(data?: ICondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fact = _data["fact"];
            this.operator = _data["operator"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Condition {
        data = typeof data === 'object' ? data : {};
        let result = new Condition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fact"] = this.fact;
        data["operator"] = this.operator;
        data["value"] = this.value;
        return data;
    }
}

export interface ICondition {
    fact?: string | undefined;
    operator?: string | undefined;
    value?: string | undefined;
}

export class Event implements IEvent {
    type?: string | undefined;
    params?: EventParams | undefined;

    constructor(data?: IEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.params = _data["params"] ? EventParams.fromJS(_data["params"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Event {
        data = typeof data === 'object' ? data : {};
        let result = new Event();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["params"] = this.params ? this.params.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEvent {
    type?: string | undefined;
    params?: EventParams | undefined;
}

export class EventParams implements IEventParams {
    message?: string[] | undefined;

    constructor(data?: IEventParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["message"])) {
                this.message = [] as any;
                for (let item of _data["message"])
                    this.message!.push(item);
            }
        }
    }

    static fromJS(data: any): EventParams {
        data = typeof data === 'object' ? data : {};
        let result = new EventParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.message)) {
            data["message"] = [];
            for (let item of this.message)
                data["message"].push(item);
        }
        return data;
    }
}

export interface IEventParams {
    message?: string[] | undefined;
}

export class FormTwoPdfPageMetaData implements IFormTwoPdfPageMetaData {
    index?: number;
    width?: number;
    height?: number;
    horizontalResolution?: number;
    verticalResolution?: number;

    constructor(data?: IFormTwoPdfPageMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.horizontalResolution = _data["horizontalResolution"];
            this.verticalResolution = _data["verticalResolution"];
        }
    }

    static fromJS(data: any): FormTwoPdfPageMetaData {
        data = typeof data === 'object' ? data : {};
        let result = new FormTwoPdfPageMetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["width"] = this.width;
        data["height"] = this.height;
        data["horizontalResolution"] = this.horizontalResolution;
        data["verticalResolution"] = this.verticalResolution;
        return data;
    }
}

export interface IFormTwoPdfPageMetaData {
    index?: number;
    width?: number;
    height?: number;
    horizontalResolution?: number;
    verticalResolution?: number;
}

export class GetFormFromSingleSourceQuery implements IGetFormFromSingleSourceQuery {

    constructor(data?: IGetFormFromSingleSourceQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetFormFromSingleSourceQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormFromSingleSourceQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetFormFromSingleSourceQuery {
}

export class CreateFormCommand implements ICreateFormCommand {
    name?: string;
    formType?: FormType;
    specialty?: Specialty;
    locationIds?: number[];
    autoSync?: boolean;
    allowAutoSync?: boolean | undefined;
    isHidden?: boolean;
    selectedLocationId?: number;
    formPmsDtos?: PmsDataDefaultDto[];
    formJson?: string;

    constructor(data?: ICreateFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.formType = _data["formType"];
            this.specialty = _data["specialty"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.autoSync = _data["autoSync"];
            this.allowAutoSync = _data["allowAutoSync"];
            this.isHidden = _data["isHidden"];
            this.selectedLocationId = _data["selectedLocationId"];
            if (Array.isArray(_data["formPmsDtos"])) {
                this.formPmsDtos = [] as any;
                for (let item of _data["formPmsDtos"])
                    this.formPmsDtos!.push(PmsDataDefaultDto.fromJS(item));
            }
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): CreateFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["formType"] = this.formType;
        data["specialty"] = this.specialty;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["autoSync"] = this.autoSync;
        data["allowAutoSync"] = this.allowAutoSync;
        data["isHidden"] = this.isHidden;
        data["selectedLocationId"] = this.selectedLocationId;
        if (Array.isArray(this.formPmsDtos)) {
            data["formPmsDtos"] = [];
            for (let item of this.formPmsDtos)
                data["formPmsDtos"].push(item.toJSON());
        }
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface ICreateFormCommand {
    name?: string;
    formType?: FormType;
    specialty?: Specialty;
    locationIds?: number[];
    autoSync?: boolean;
    allowAutoSync?: boolean | undefined;
    isHidden?: boolean;
    selectedLocationId?: number;
    formPmsDtos?: PmsDataDefaultDto[];
    formJson?: string;
}

export class ImportFormCommand implements IImportFormCommand {
    name?: string | undefined;
    formType?: FormType;
    specialty?: Specialty;
    locationIds?: number[] | undefined;
    formJson?: string | undefined;

    constructor(data?: IImportFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.formType = _data["formType"];
            this.specialty = _data["specialty"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): ImportFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["formType"] = this.formType;
        data["specialty"] = this.specialty;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IImportFormCommand {
    name?: string | undefined;
    formType?: FormType;
    specialty?: Specialty;
    locationIds?: number[] | undefined;
    formJson?: string | undefined;
}

export class ImportCustomFormCommand implements IImportCustomFormCommand {
    name?: string;
    formType?: FormType;
    specialty?: Specialty;
    accountId?: number | undefined;
    sourceType?: ImportSource | undefined;
    sourceId?: number | undefined;
    isPublic?: boolean;
    isDeleted?: boolean;
    locationIds?: number[];
    formJson?: string;

    constructor(data?: IImportCustomFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.formType = _data["formType"];
            this.specialty = _data["specialty"];
            this.accountId = _data["accountId"];
            this.sourceType = _data["sourceType"];
            this.sourceId = _data["sourceId"];
            this.isPublic = _data["isPublic"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): ImportCustomFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCustomFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["formType"] = this.formType;
        data["specialty"] = this.specialty;
        data["accountId"] = this.accountId;
        data["sourceType"] = this.sourceType;
        data["sourceId"] = this.sourceId;
        data["isPublic"] = this.isPublic;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IImportCustomFormCommand {
    name?: string;
    formType?: FormType;
    specialty?: Specialty;
    accountId?: number | undefined;
    sourceType?: ImportSource | undefined;
    sourceId?: number | undefined;
    isPublic?: boolean;
    isDeleted?: boolean;
    locationIds?: number[];
    formJson?: string;
}

export enum ImportSource {
    SingleSource = 0,
    Forms1 = 1,
}

export class UpdateImportedFormCommand implements IUpdateImportedFormCommand {
    accountId?: number;
    networkId?: number;
    sourceId?: number;
    sourceType?: number;
    pmsExternalId?: string;
    isPublic?: boolean;
    locationIds?: number[];

    constructor(data?: IUpdateImportedFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.networkId = _data["networkId"];
            this.sourceId = _data["sourceId"];
            this.sourceType = _data["sourceType"];
            this.pmsExternalId = _data["pmsExternalId"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateImportedFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImportedFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["networkId"] = this.networkId;
        data["sourceId"] = this.sourceId;
        data["sourceType"] = this.sourceType;
        data["pmsExternalId"] = this.pmsExternalId;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateImportedFormCommand {
    accountId?: number;
    networkId?: number;
    sourceId?: number;
    sourceType?: number;
    pmsExternalId?: string;
    isPublic?: boolean;
    locationIds?: number[];
}

export class ImportEagleSoftHealthHistoryFormCommand implements IImportEagleSoftHealthHistoryFormCommand {
    name?: string;
    accountId?: number | undefined;
    networkId?: number;
    sourceId?: number | undefined;
    sourceType?: number;
    pmsExternalId?: string;
    isPublic?: boolean;
    locationIds?: number[];

    constructor(data?: IImportEagleSoftHealthHistoryFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.accountId = _data["accountId"];
            this.networkId = _data["networkId"];
            this.sourceId = _data["sourceId"];
            this.sourceType = _data["sourceType"];
            this.pmsExternalId = _data["pmsExternalId"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportEagleSoftHealthHistoryFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportEagleSoftHealthHistoryFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accountId"] = this.accountId;
        data["networkId"] = this.networkId;
        data["sourceId"] = this.sourceId;
        data["sourceType"] = this.sourceType;
        data["pmsExternalId"] = this.pmsExternalId;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        return data;
    }
}

export interface IImportEagleSoftHealthHistoryFormCommand {
    name?: string;
    accountId?: number | undefined;
    networkId?: number;
    sourceId?: number | undefined;
    sourceType?: number;
    pmsExternalId?: string;
    isPublic?: boolean;
    locationIds?: number[];
}

export class ImportHealthHistoryFormCommand implements IImportHealthHistoryFormCommand {
    accountId?: number | undefined;
    name?: string;
    formType?: FormType;
    specialty?: Specialty;
    sourceType?: ImportSource | undefined;
    sourceId?: number | undefined;
    isPublic?: boolean;
    locationIds?: number[];

    constructor(data?: IImportHealthHistoryFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.name = _data["name"];
            this.formType = _data["formType"];
            this.specialty = _data["specialty"];
            this.sourceType = _data["sourceType"];
            this.sourceId = _data["sourceId"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportHealthHistoryFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportHealthHistoryFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["name"] = this.name;
        data["formType"] = this.formType;
        data["specialty"] = this.specialty;
        data["sourceType"] = this.sourceType;
        data["sourceId"] = this.sourceId;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        return data;
    }
}

export interface IImportHealthHistoryFormCommand {
    accountId?: number | undefined;
    name?: string;
    formType?: FormType;
    specialty?: Specialty;
    sourceType?: ImportSource | undefined;
    sourceId?: number | undefined;
    isPublic?: boolean;
    locationIds?: number[];
}

export class ImportBuiltInFormCommand implements IImportBuiltInFormCommand {
    name?: string | undefined;
    formType?: FormType;
    templateType?: FormTemplateType;
    specialty?: Specialty;
    accountId?: number | undefined;
    sourceType?: ImportSource | undefined;
    sourceId?: number | undefined;
    isPublic?: boolean;
    locationIds?: number[] | undefined;
    formJson?: string | undefined;

    constructor(data?: IImportBuiltInFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.formType = _data["formType"];
            this.templateType = _data["templateType"];
            this.specialty = _data["specialty"];
            this.accountId = _data["accountId"];
            this.sourceType = _data["sourceType"];
            this.sourceId = _data["sourceId"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): ImportBuiltInFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportBuiltInFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["formType"] = this.formType;
        data["templateType"] = this.templateType;
        data["specialty"] = this.specialty;
        data["accountId"] = this.accountId;
        data["sourceType"] = this.sourceType;
        data["sourceId"] = this.sourceId;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IImportBuiltInFormCommand {
    name?: string | undefined;
    formType?: FormType;
    templateType?: FormTemplateType;
    specialty?: Specialty;
    accountId?: number | undefined;
    sourceType?: ImportSource | undefined;
    sourceId?: number | undefined;
    isPublic?: boolean;
    locationIds?: number[] | undefined;
    formJson?: string | undefined;
}

export class UpdateFormDataCommand implements IUpdateFormDataCommand {
    formId?: string;
    formJson?: string | undefined;
    locationId?: number;
    hasPracticeSignature?: boolean;

    constructor(data?: IUpdateFormDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.formJson = _data["formJson"];
            this.locationId = _data["locationId"];
            this.hasPracticeSignature = _data["hasPracticeSignature"];
        }
    }

    static fromJS(data: any): UpdateFormDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formJson"] = this.formJson;
        data["locationId"] = this.locationId;
        data["hasPracticeSignature"] = this.hasPracticeSignature;
        return data;
    }
}

export interface IUpdateFormDataCommand {
    formId?: string;
    formJson?: string | undefined;
    locationId?: number;
    hasPracticeSignature?: boolean;
}

export class UpdateFormMedicationsCommand implements IUpdateFormMedicationsCommand {

    constructor(data?: IUpdateFormMedicationsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateFormMedicationsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormMedicationsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateFormMedicationsCommand {
}

export class CreateFormDataAssignCommand implements ICreateFormDataAssignCommand {
    name?: string | undefined;
    formJson?: string | undefined;
    contact?: RwContactUploadFormDto | undefined;

    constructor(data?: ICreateFormDataAssignCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.formJson = _data["formJson"];
            this.contact = _data["contact"] ? RwContactUploadFormDto.fromJS(_data["contact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFormDataAssignCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormDataAssignCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["formJson"] = this.formJson;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateFormDataAssignCommand {
    name?: string | undefined;
    formJson?: string | undefined;
    contact?: RwContactUploadFormDto | undefined;
}

export class RwContactUploadFormDto extends RwContactDto implements IRwContactUploadFormDto {
    isResponsibleParty?: boolean;

    constructor(data?: IRwContactUploadFormDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isResponsibleParty = _data["isResponsibleParty"];
        }
    }

    static override fromJS(data: any): RwContactUploadFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new RwContactUploadFormDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isResponsibleParty"] = this.isResponsibleParty;
        super.toJSON(data);
        return data;
    }
}

export interface IRwContactUploadFormDto extends IRwContactDto {
    isResponsibleParty?: boolean;
}

export class UpdateFormAutoSyncCommand implements IUpdateFormAutoSyncCommand {
    id?: string;
    autoSync?: boolean;
    autoSyncNotAllowed?: boolean;

    constructor(data?: IUpdateFormAutoSyncCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.autoSync = _data["autoSync"];
            this.autoSyncNotAllowed = _data["autoSyncNotAllowed"];
        }
    }

    static fromJS(data: any): UpdateFormAutoSyncCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormAutoSyncCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["autoSync"] = this.autoSync;
        data["autoSyncNotAllowed"] = this.autoSyncNotAllowed;
        return data;
    }
}

export interface IUpdateFormAutoSyncCommand {
    id?: string;
    autoSync?: boolean;
    autoSyncNotAllowed?: boolean;
}

export class UpdateFormCommand implements IUpdateFormCommand {
    id?: string;
    name?: string | undefined;
    formType?: FormType;
    specialty?: Specialty;
    locationIds?: number[] | undefined;
    autoSync?: boolean;
    isHidden?: boolean;
    formPmsDtos?: PmsDataDefaultDto[] | undefined;

    constructor(data?: IUpdateFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.formType = _data["formType"];
            this.specialty = _data["specialty"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.autoSync = _data["autoSync"];
            this.isHidden = _data["isHidden"];
            if (Array.isArray(_data["formPmsDtos"])) {
                this.formPmsDtos = [] as any;
                for (let item of _data["formPmsDtos"])
                    this.formPmsDtos!.push(PmsDataDefaultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["formType"] = this.formType;
        data["specialty"] = this.specialty;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["autoSync"] = this.autoSync;
        data["isHidden"] = this.isHidden;
        if (Array.isArray(this.formPmsDtos)) {
            data["formPmsDtos"] = [];
            for (let item of this.formPmsDtos)
                data["formPmsDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateFormCommand {
    id?: string;
    name?: string | undefined;
    formType?: FormType;
    specialty?: Specialty;
    locationIds?: number[] | undefined;
    autoSync?: boolean;
    isHidden?: boolean;
    formPmsDtos?: PmsDataDefaultDto[] | undefined;
}

export class DeleteFormCommand implements IDeleteFormCommand {
    id?: string;

    constructor(data?: IDeleteFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteFormCommand {
    id?: string;
}

export class DuplicateFormCommand implements IDuplicateFormCommand {
    id?: string;
    locationIds?: number[] | undefined;

    constructor(data?: IDuplicateFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DuplicateFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        return data;
    }
}

export interface IDuplicateFormCommand {
    id?: string;
    locationIds?: number[] | undefined;
}

export class CreateFormFromTemplateCommand implements ICreateFormFromTemplateCommand {
    type?: FormTemplateType;
    locationId?: number;
    formType?: FormType | undefined;

    constructor(data?: ICreateFormFromTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.locationId = _data["locationId"];
            this.formType = _data["formType"];
        }
    }

    static fromJS(data: any): CreateFormFromTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormFromTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["locationId"] = this.locationId;
        data["formType"] = this.formType;
        return data;
    }
}

export interface ICreateFormFromTemplateCommand {
    type?: FormTemplateType;
    locationId?: number;
    formType?: FormType | undefined;
}

export class CreateFormLinkCommand implements ICreateFormLinkCommand {
    id?: string;
    locationId?: number;

    constructor(data?: ICreateFormLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): CreateFormLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface ICreateFormLinkCommand {
    id?: string;
    locationId?: number;
}

export class FormUrlDto implements IFormUrlDto {
    index?: number;
    id?: string;
    name?: string;
    link?: string;

    constructor(data?: IFormUrlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): FormUrlDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormUrlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["id"] = this.id;
        data["name"] = this.name;
        data["link"] = this.link;
        return data;
    }
}

export interface IFormUrlDto {
    index?: number;
    id?: string;
    name?: string;
    link?: string;
}

export class FormSubmissionDto implements IFormSubmissionDto {
    id?: string;
    index?: number;
    formId?: string;
    formIndex?: number;
    staticFormDataId?: string;
    name?: string;
    patientName?: string;
    created?: Date;
    rwPmsProviderForeignId?: string;
    rwPmsDocumentCategoryForeignId?: string;
    completed?: boolean;
    read?: boolean;
    rwLocationId?: number;
    rwPatientId?: number | undefined;
    patientDateOfBirth?: Date | undefined;
    patientDateOfBirthDisplay?: string;
    patientForeignId?: string;
    status?: FormSubmissionWriteBackStatus;
    dateWriteBackStatusUpdated?: Date | undefined;
    writeBackStatusTimeString?: string;
    formAutoSync?: boolean;
    submissionJson?: string;
    requiresPracticeSignature?: boolean;
    externalSystemType?: string;
    azureBlobFormSasUri?: string;
    currentUserId?: number | undefined;
    userProfileName?: string;

    constructor(data?: IFormSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.index = _data["index"];
            this.formId = _data["formId"];
            this.formIndex = _data["formIndex"];
            this.staticFormDataId = _data["staticFormDataId"];
            this.name = _data["name"];
            this.patientName = _data["patientName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.rwPmsProviderForeignId = _data["rwPmsProviderForeignId"];
            this.rwPmsDocumentCategoryForeignId = _data["rwPmsDocumentCategoryForeignId"];
            this.completed = _data["completed"];
            this.read = _data["read"];
            this.rwLocationId = _data["rwLocationId"];
            this.rwPatientId = _data["rwPatientId"];
            this.patientDateOfBirth = _data["patientDateOfBirth"] ? new Date(_data["patientDateOfBirth"].toString()) : <any>undefined;
            this.patientDateOfBirthDisplay = _data["patientDateOfBirthDisplay"];
            this.patientForeignId = _data["patientForeignId"];
            this.status = _data["status"];
            this.dateWriteBackStatusUpdated = _data["dateWriteBackStatusUpdated"] ? new Date(_data["dateWriteBackStatusUpdated"].toString()) : <any>undefined;
            this.writeBackStatusTimeString = _data["writeBackStatusTimeString"];
            this.formAutoSync = _data["formAutoSync"];
            this.submissionJson = _data["submissionJson"];
            this.requiresPracticeSignature = _data["requiresPracticeSignature"];
            this.externalSystemType = _data["externalSystemType"];
            this.azureBlobFormSasUri = _data["azureBlobFormSasUri"];
            this.currentUserId = _data["currentUserId"];
            this.userProfileName = _data["userProfileName"];
        }
    }

    static fromJS(data: any): FormSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["index"] = this.index;
        data["formId"] = this.formId;
        data["formIndex"] = this.formIndex;
        data["staticFormDataId"] = this.staticFormDataId;
        data["name"] = this.name;
        data["patientName"] = this.patientName;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["rwPmsProviderForeignId"] = this.rwPmsProviderForeignId;
        data["rwPmsDocumentCategoryForeignId"] = this.rwPmsDocumentCategoryForeignId;
        data["completed"] = this.completed;
        data["read"] = this.read;
        data["rwLocationId"] = this.rwLocationId;
        data["rwPatientId"] = this.rwPatientId;
        data["patientDateOfBirth"] = this.patientDateOfBirth ? this.patientDateOfBirth.toISOString() : <any>undefined;
        data["patientDateOfBirthDisplay"] = this.patientDateOfBirthDisplay;
        data["patientForeignId"] = this.patientForeignId;
        data["status"] = this.status;
        data["dateWriteBackStatusUpdated"] = this.dateWriteBackStatusUpdated ? this.dateWriteBackStatusUpdated.toISOString() : <any>undefined;
        data["writeBackStatusTimeString"] = this.writeBackStatusTimeString;
        data["formAutoSync"] = this.formAutoSync;
        data["submissionJson"] = this.submissionJson;
        data["requiresPracticeSignature"] = this.requiresPracticeSignature;
        data["externalSystemType"] = this.externalSystemType;
        data["azureBlobFormSasUri"] = this.azureBlobFormSasUri;
        data["currentUserId"] = this.currentUserId;
        data["userProfileName"] = this.userProfileName;
        return data;
    }
}

export interface IFormSubmissionDto {
    id?: string;
    index?: number;
    formId?: string;
    formIndex?: number;
    staticFormDataId?: string;
    name?: string;
    patientName?: string;
    created?: Date;
    rwPmsProviderForeignId?: string;
    rwPmsDocumentCategoryForeignId?: string;
    completed?: boolean;
    read?: boolean;
    rwLocationId?: number;
    rwPatientId?: number | undefined;
    patientDateOfBirth?: Date | undefined;
    patientDateOfBirthDisplay?: string;
    patientForeignId?: string;
    status?: FormSubmissionWriteBackStatus;
    dateWriteBackStatusUpdated?: Date | undefined;
    writeBackStatusTimeString?: string;
    formAutoSync?: boolean;
    submissionJson?: string;
    requiresPracticeSignature?: boolean;
    externalSystemType?: string;
    azureBlobFormSasUri?: string;
    currentUserId?: number | undefined;
    userProfileName?: string;
}

export enum FormSubmissionWriteBackStatus {
    None = 0,
    NotSupported = 1,
    BeginProcessing = 2,
    Success = 3,
    Failed = 4,
    Dismissed = 5,
}

export class CreateOrUpdateFormSubmissionCommand implements ICreateOrUpdateFormSubmissionCommand {
    formId?: string;
    formAssignmentId?: string | undefined;
    formSubmissionJson?: string | undefined;
    requiresPracticeSignature?: boolean;
    submittedBy?: FormSubmissionSubmittedBy;

    constructor(data?: ICreateOrUpdateFormSubmissionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.formAssignmentId = _data["formAssignmentId"];
            this.formSubmissionJson = _data["formSubmissionJson"];
            this.requiresPracticeSignature = _data["requiresPracticeSignature"];
            this.submittedBy = _data["submittedBy"];
        }
    }

    static fromJS(data: any): CreateOrUpdateFormSubmissionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateFormSubmissionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formAssignmentId"] = this.formAssignmentId;
        data["formSubmissionJson"] = this.formSubmissionJson;
        data["requiresPracticeSignature"] = this.requiresPracticeSignature;
        data["submittedBy"] = this.submittedBy;
        return data;
    }
}

export interface ICreateOrUpdateFormSubmissionCommand {
    formId?: string;
    formAssignmentId?: string | undefined;
    formSubmissionJson?: string | undefined;
    requiresPracticeSignature?: boolean;
    submittedBy?: FormSubmissionSubmittedBy;
}

export class FormSubmissionListDto implements IFormSubmissionListDto {
    id?: string;
    index?: number;
    formName?: string;
    patientName?: string;
    patientDateOfBirth?: Date | undefined;
    created?: Date;
    lastModified?: Date | undefined;
    lastModifiedBy?: string;
    lastModifiedString?: string;
    read?: boolean;
    hasAttachments?: boolean;
    requiresPracticeSignature?: boolean;
    status?: FormSubmissionWriteBackStatus;
    formAssignmentDto?: FormAssignmentDto | undefined;

    constructor(data?: IFormSubmissionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.index = _data["index"];
            this.formName = _data["formName"];
            this.patientName = _data["patientName"];
            this.patientDateOfBirth = _data["patientDateOfBirth"] ? new Date(_data["patientDateOfBirth"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedString = _data["lastModifiedString"];
            this.read = _data["read"];
            this.hasAttachments = _data["hasAttachments"];
            this.requiresPracticeSignature = _data["requiresPracticeSignature"];
            this.status = _data["status"];
            this.formAssignmentDto = _data["formAssignmentDto"] ? FormAssignmentDto.fromJS(_data["formAssignmentDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormSubmissionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormSubmissionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["index"] = this.index;
        data["formName"] = this.formName;
        data["patientName"] = this.patientName;
        data["patientDateOfBirth"] = this.patientDateOfBirth ? this.patientDateOfBirth.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedString"] = this.lastModifiedString;
        data["read"] = this.read;
        data["hasAttachments"] = this.hasAttachments;
        data["requiresPracticeSignature"] = this.requiresPracticeSignature;
        data["status"] = this.status;
        data["formAssignmentDto"] = this.formAssignmentDto ? this.formAssignmentDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFormSubmissionListDto {
    id?: string;
    index?: number;
    formName?: string;
    patientName?: string;
    patientDateOfBirth?: Date | undefined;
    created?: Date;
    lastModified?: Date | undefined;
    lastModifiedBy?: string;
    lastModifiedString?: string;
    read?: boolean;
    hasAttachments?: boolean;
    requiresPracticeSignature?: boolean;
    status?: FormSubmissionWriteBackStatus;
    formAssignmentDto?: FormAssignmentDto | undefined;
}

export enum FormSubmissionFilter {
    All = 0,
    New = 1,
    Dismissed = 2,
    Failed = 3,
    Processing = 4,
    Synced = 5,
    Signatures = 6,
}

export class PmsInfoDto implements IPmsInfoDto {
    location?: number;
    providers?: RwProvider[];
    documentCategories?: RwDocumentCategory[];
    externalSystemType?: string;

    constructor(data?: IPmsInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            if (Array.isArray(_data["providers"])) {
                this.providers = [] as any;
                for (let item of _data["providers"])
                    this.providers!.push(RwProvider.fromJS(item));
            }
            if (Array.isArray(_data["documentCategories"])) {
                this.documentCategories = [] as any;
                for (let item of _data["documentCategories"])
                    this.documentCategories!.push(RwDocumentCategory.fromJS(item));
            }
            this.externalSystemType = _data["externalSystemType"];
        }
    }

    static fromJS(data: any): PmsInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PmsInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        if (Array.isArray(this.providers)) {
            data["providers"] = [];
            for (let item of this.providers)
                data["providers"].push(item.toJSON());
        }
        if (Array.isArray(this.documentCategories)) {
            data["documentCategories"] = [];
            for (let item of this.documentCategories)
                data["documentCategories"].push(item.toJSON());
        }
        data["externalSystemType"] = this.externalSystemType;
        return data;
    }
}

export interface IPmsInfoDto {
    location?: number;
    providers?: RwProvider[];
    documentCategories?: RwDocumentCategory[];
    externalSystemType?: string;
}

export class RwProvider implements IRwProvider {
    idNetwork?: number;
    foreignId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    canSubmitPayment?: boolean;
    locationId?: string | undefined;
    id?: string | undefined;

    constructor(data?: IRwProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idNetwork = _data["idNetwork"];
            this.foreignId = _data["foreignId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isDeleted = _data["isDeleted"];
            this.canSubmitPayment = _data["canSubmitPayment"];
            this.locationId = _data["locationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RwProvider {
        data = typeof data === 'object' ? data : {};
        let result = new RwProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idNetwork"] = this.idNetwork;
        data["foreignId"] = this.foreignId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isDeleted"] = this.isDeleted;
        data["canSubmitPayment"] = this.canSubmitPayment;
        data["locationId"] = this.locationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRwProvider {
    idNetwork?: number;
    foreignId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    canSubmitPayment?: boolean;
    locationId?: string | undefined;
    id?: string | undefined;
}

export class RwDocumentCategory implements IRwDocumentCategory {
    idNetwork?: number;
    foreignId?: string | undefined;
    name?: string | undefined;
    isDeleted?: boolean;
    locationId?: string | undefined;
    id?: string | undefined;

    constructor(data?: IRwDocumentCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idNetwork = _data["idNetwork"];
            this.foreignId = _data["foreignId"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
            this.locationId = _data["locationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RwDocumentCategory {
        data = typeof data === 'object' ? data : {};
        let result = new RwDocumentCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idNetwork"] = this.idNetwork;
        data["foreignId"] = this.foreignId;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["locationId"] = this.locationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRwDocumentCategory {
    idNetwork?: number;
    foreignId?: string | undefined;
    name?: string | undefined;
    isDeleted?: boolean;
    locationId?: string | undefined;
    id?: string | undefined;
}

export class FormSubmissionsVm implements IFormSubmissionsVm {
    count?: number;
    unreadCount?: number;

    constructor(data?: IFormSubmissionsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.unreadCount = _data["unreadCount"];
        }
    }

    static fromJS(data: any): FormSubmissionsVm {
        data = typeof data === 'object' ? data : {};
        let result = new FormSubmissionsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["unreadCount"] = this.unreadCount;
        return data;
    }
}

export interface IFormSubmissionsVm {
    count?: number;
    unreadCount?: number;
}

export class UpdateSubmissionPracticeSignatureCommand implements IUpdateSubmissionPracticeSignatureCommand {
    submissionId?: string;
    formSubmissionJson?: string;

    constructor(data?: IUpdateSubmissionPracticeSignatureCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.formSubmissionJson = _data["formSubmissionJson"];
        }
    }

    static fromJS(data: any): UpdateSubmissionPracticeSignatureCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubmissionPracticeSignatureCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["formSubmissionJson"] = this.formSubmissionJson;
        return data;
    }
}

export interface IUpdateSubmissionPracticeSignatureCommand {
    submissionId?: string;
    formSubmissionJson?: string;
}

export class UpdateFormSubmissionSetStatusAndCompletedCommand implements IUpdateFormSubmissionSetStatusAndCompletedCommand {
    id?: string;
    writeBackStatus?: FormSubmissionWriteBackStatus;
    completed?: boolean;

    constructor(data?: IUpdateFormSubmissionSetStatusAndCompletedCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.writeBackStatus = _data["writeBackStatus"];
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): UpdateFormSubmissionSetStatusAndCompletedCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormSubmissionSetStatusAndCompletedCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["writeBackStatus"] = this.writeBackStatus;
        data["completed"] = this.completed;
        return data;
    }
}

export interface IUpdateFormSubmissionSetStatusAndCompletedCommand {
    id?: string;
    writeBackStatus?: FormSubmissionWriteBackStatus;
    completed?: boolean;
}

export class CompleteSubmissionCommand implements ICompleteSubmissionCommand {
    submissionId?: string;
    dismiss?: boolean;
    rwLocationId?: number;
    rwPmsProviderForeignId?: string;
    rwPmsDocumentCategoryForeignId?: string;
    rwPatientId?: number | undefined;
    submissionUpdates?: string[];
    formSubmissionJson?: string;

    constructor(data?: ICompleteSubmissionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.dismiss = _data["dismiss"];
            this.rwLocationId = _data["rwLocationId"];
            this.rwPmsProviderForeignId = _data["rwPmsProviderForeignId"];
            this.rwPmsDocumentCategoryForeignId = _data["rwPmsDocumentCategoryForeignId"];
            this.rwPatientId = _data["rwPatientId"];
            if (Array.isArray(_data["submissionUpdates"])) {
                this.submissionUpdates = [] as any;
                for (let item of _data["submissionUpdates"])
                    this.submissionUpdates!.push(item);
            }
            this.formSubmissionJson = _data["formSubmissionJson"];
        }
    }

    static fromJS(data: any): CompleteSubmissionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteSubmissionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["dismiss"] = this.dismiss;
        data["rwLocationId"] = this.rwLocationId;
        data["rwPmsProviderForeignId"] = this.rwPmsProviderForeignId;
        data["rwPmsDocumentCategoryForeignId"] = this.rwPmsDocumentCategoryForeignId;
        data["rwPatientId"] = this.rwPatientId;
        if (Array.isArray(this.submissionUpdates)) {
            data["submissionUpdates"] = [];
            for (let item of this.submissionUpdates)
                data["submissionUpdates"].push(item);
        }
        data["formSubmissionJson"] = this.formSubmissionJson;
        return data;
    }
}

export interface ICompleteSubmissionCommand {
    submissionId?: string;
    dismiss?: boolean;
    rwLocationId?: number;
    rwPmsProviderForeignId?: string;
    rwPmsDocumentCategoryForeignId?: string;
    rwPatientId?: number | undefined;
    submissionUpdates?: string[];
    formSubmissionJson?: string;
}

export class FormSubmissionForPatientDto implements IFormSubmissionForPatientDto {
    id?: string;
    formId?: string;
    name?: string;
    date?: Date;

    constructor(data?: IFormSubmissionForPatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formId = _data["formId"];
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FormSubmissionForPatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormSubmissionForPatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formId"] = this.formId;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFormSubmissionForPatientDto {
    id?: string;
    formId?: string;
    name?: string;
    date?: Date;
}

export class LegacyFormSubmissionDto implements ILegacyFormSubmissionDto {
    id?: number;
    formName?: string;
    date?: Date | undefined;
    pmsId?: string;
    status?: string;

    constructor(data?: ILegacyFormSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formName = _data["formName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.pmsId = _data["pmsId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LegacyFormSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegacyFormSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formName"] = this.formName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["pmsId"] = this.pmsId;
        data["status"] = this.status;
        return data;
    }
}

export interface ILegacyFormSubmissionDto {
    id?: number;
    formName?: string;
    date?: Date | undefined;
    pmsId?: string;
    status?: string;
}

export class LocationDto implements ILocationDto {
    rwLocationId?: number;
    name?: string;
    address?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
    phone?: string;
    accountStatus?: AccountStatus;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rwLocationId = _data["rwLocationId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.phone = _data["phone"];
            this.accountStatus = _data["accountStatus"];
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rwLocationId"] = this.rwLocationId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["phone"] = this.phone;
        data["accountStatus"] = this.accountStatus;
        return data;
    }
}

export interface ILocationDto {
    rwLocationId?: number;
    name?: string;
    address?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
    phone?: string;
    accountStatus?: AccountStatus;
}

export enum AccountStatus {
    Active = 0,
    Boarding = 1,
    Cancelled = 3,
    Deleted = 5,
    Creating = 6,
}

export class FormsMigrationStatusDto implements IFormsMigrationStatusDto {
    rwLocationId?: number;
    isMigrationTurnedOn?: boolean;
    isMigrationBannerVisible?: boolean;
    hasUserClickedOnBannerToMigrate?: boolean;
    migrationStatus?: string;
    isSuccess?: boolean;
    errors?: string[];

    constructor(data?: IFormsMigrationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rwLocationId = _data["rwLocationId"];
            this.isMigrationTurnedOn = _data["isMigrationTurnedOn"];
            this.isMigrationBannerVisible = _data["isMigrationBannerVisible"];
            this.hasUserClickedOnBannerToMigrate = _data["hasUserClickedOnBannerToMigrate"];
            this.migrationStatus = _data["migrationStatus"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): FormsMigrationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormsMigrationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rwLocationId"] = this.rwLocationId;
        data["isMigrationTurnedOn"] = this.isMigrationTurnedOn;
        data["isMigrationBannerVisible"] = this.isMigrationBannerVisible;
        data["hasUserClickedOnBannerToMigrate"] = this.hasUserClickedOnBannerToMigrate;
        data["migrationStatus"] = this.migrationStatus;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IFormsMigrationStatusDto {
    rwLocationId?: number;
    isMigrationTurnedOn?: boolean;
    isMigrationBannerVisible?: boolean;
    hasUserClickedOnBannerToMigrate?: boolean;
    migrationStatus?: string;
    isSuccess?: boolean;
    errors?: string[];
}

export class RwPayer implements IRwPayer {
    id?: string | undefined;
    name?: string | undefined;
    idWebsite?: string | undefined;
    website?: Website | undefined;
    address?: string | undefined;
    alternateIds?: string[] | undefined;
    alternateNames?: string[] | undefined;

    constructor(data?: IRwPayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.idWebsite = _data["idWebsite"];
            this.website = _data["website"] ? Website.fromJS(_data["website"]) : <any>undefined;
            this.address = _data["address"];
            if (Array.isArray(_data["alternateIds"])) {
                this.alternateIds = [] as any;
                for (let item of _data["alternateIds"])
                    this.alternateIds!.push(item);
            }
            if (Array.isArray(_data["alternateNames"])) {
                this.alternateNames = [] as any;
                for (let item of _data["alternateNames"])
                    this.alternateNames!.push(item);
            }
        }
    }

    static fromJS(data: any): RwPayer {
        data = typeof data === 'object' ? data : {};
        let result = new RwPayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["idWebsite"] = this.idWebsite;
        data["website"] = this.website ? this.website.toJSON() : <any>undefined;
        data["address"] = this.address;
        if (Array.isArray(this.alternateIds)) {
            data["alternateIds"] = [];
            for (let item of this.alternateIds)
                data["alternateIds"].push(item);
        }
        if (Array.isArray(this.alternateNames)) {
            data["alternateNames"] = [];
            for (let item of this.alternateNames)
                data["alternateNames"].push(item);
        }
        return data;
    }
}

export interface IRwPayer {
    id?: string | undefined;
    name?: string | undefined;
    idWebsite?: string | undefined;
    website?: Website | undefined;
    address?: string | undefined;
    alternateIds?: string[] | undefined;
    alternateNames?: string[] | undefined;
}

export class Website implements IWebsite {
    id?: string | undefined;
    url?: string | undefined;
    hasMfa?: boolean;

    constructor(data?: IWebsite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.hasMfa = _data["hasMfa"];
        }
    }

    static fromJS(data: any): Website {
        data = typeof data === 'object' ? data : {};
        let result = new Website();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["hasMfa"] = this.hasMfa;
        return data;
    }
}

export interface IWebsite {
    id?: string | undefined;
    url?: string | undefined;
    hasMfa?: boolean;
}

export class OidcSettings implements IOidcSettings {
    authority?: string;
    internalApiClient?: string;
    internalApiClientSecret?: string;
    productMenuApiUrl?: string;
    clientId?: string;
    redirectUri?: string;
    postLogoutRedirectUri?: string;
    acrValues?: string;
    responseType?: string;
    loadUserInfo?: boolean;
    scope?: string;
    serverClientId?: string;
    serverClientSecret?: string;
    accountApiUrl?: string;
    contactsApiUrl?: string;
    messengerApiUrl?: string;
    accessControlApiUrl?: string;
    pmsConnectorApiUrl?: string;
    singleSourceApiUrl?: string;
    productApiUrl?: string;
    contactDomain?: string;
    phoneDomain?: string;
    featureFlagsDomain?: string;
    unifiedWrapperDomain?: string;
    textSenderApiUrl?: string;
    fdaApiUrl?: string;
    intercomAppId?: string;
    appointmentApiUrl?: string;
    universalPatientSearchApiUrl?: string;
    insuranceVerification2ApiUrl?: string;
    leadManagementMilaApiUrl?: string;
    userProfileApiUrl?: string;
    enterpriseFormsApiUrl?: string;

    constructor(data?: IOidcSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authority = _data["authority"];
            this.internalApiClient = _data["internalApiClient"];
            this.internalApiClientSecret = _data["internalApiClientSecret"];
            this.productMenuApiUrl = _data["productMenuApiUrl"];
            this.clientId = _data["clientId"];
            this.redirectUri = _data["redirectUri"];
            this.postLogoutRedirectUri = _data["postLogoutRedirectUri"];
            this.acrValues = _data["acrValues"];
            this.responseType = _data["responseType"];
            this.loadUserInfo = _data["loadUserInfo"];
            this.scope = _data["scope"];
            this.serverClientId = _data["serverClientId"];
            this.serverClientSecret = _data["serverClientSecret"];
            this.accountApiUrl = _data["accountApiUrl"];
            this.contactsApiUrl = _data["contactsApiUrl"];
            this.messengerApiUrl = _data["messengerApiUrl"];
            this.accessControlApiUrl = _data["accessControlApiUrl"];
            this.pmsConnectorApiUrl = _data["pmsConnectorApiUrl"];
            this.singleSourceApiUrl = _data["singleSourceApiUrl"];
            this.productApiUrl = _data["productApiUrl"];
            this.contactDomain = _data["contactDomain"];
            this.phoneDomain = _data["phoneDomain"];
            this.featureFlagsDomain = _data["featureFlagsDomain"];
            this.unifiedWrapperDomain = _data["unifiedWrapperDomain"];
            this.textSenderApiUrl = _data["textSenderApiUrl"];
            this.fdaApiUrl = _data["fdaApiUrl"];
            this.intercomAppId = _data["intercomAppId"];
            this.appointmentApiUrl = _data["appointmentApiUrl"];
            this.universalPatientSearchApiUrl = _data["universalPatientSearchApiUrl"];
            this.insuranceVerification2ApiUrl = _data["insuranceVerification2ApiUrl"];
            this.leadManagementMilaApiUrl = _data["leadManagementMilaApiUrl"];
            this.userProfileApiUrl = _data["userProfileApiUrl"];
            this.enterpriseFormsApiUrl = _data["enterpriseFormsApiUrl"];
        }
    }

    static fromJS(data: any): OidcSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OidcSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authority"] = this.authority;
        data["internalApiClient"] = this.internalApiClient;
        data["internalApiClientSecret"] = this.internalApiClientSecret;
        data["productMenuApiUrl"] = this.productMenuApiUrl;
        data["clientId"] = this.clientId;
        data["redirectUri"] = this.redirectUri;
        data["postLogoutRedirectUri"] = this.postLogoutRedirectUri;
        data["acrValues"] = this.acrValues;
        data["responseType"] = this.responseType;
        data["loadUserInfo"] = this.loadUserInfo;
        data["scope"] = this.scope;
        data["serverClientId"] = this.serverClientId;
        data["serverClientSecret"] = this.serverClientSecret;
        data["accountApiUrl"] = this.accountApiUrl;
        data["contactsApiUrl"] = this.contactsApiUrl;
        data["messengerApiUrl"] = this.messengerApiUrl;
        data["accessControlApiUrl"] = this.accessControlApiUrl;
        data["pmsConnectorApiUrl"] = this.pmsConnectorApiUrl;
        data["singleSourceApiUrl"] = this.singleSourceApiUrl;
        data["productApiUrl"] = this.productApiUrl;
        data["contactDomain"] = this.contactDomain;
        data["phoneDomain"] = this.phoneDomain;
        data["featureFlagsDomain"] = this.featureFlagsDomain;
        data["unifiedWrapperDomain"] = this.unifiedWrapperDomain;
        data["textSenderApiUrl"] = this.textSenderApiUrl;
        data["fdaApiUrl"] = this.fdaApiUrl;
        data["intercomAppId"] = this.intercomAppId;
        data["appointmentApiUrl"] = this.appointmentApiUrl;
        data["universalPatientSearchApiUrl"] = this.universalPatientSearchApiUrl;
        data["insuranceVerification2ApiUrl"] = this.insuranceVerification2ApiUrl;
        data["leadManagementMilaApiUrl"] = this.leadManagementMilaApiUrl;
        data["userProfileApiUrl"] = this.userProfileApiUrl;
        data["enterpriseFormsApiUrl"] = this.enterpriseFormsApiUrl;
        return data;
    }
}

export interface IOidcSettings {
    authority?: string;
    internalApiClient?: string;
    internalApiClientSecret?: string;
    productMenuApiUrl?: string;
    clientId?: string;
    redirectUri?: string;
    postLogoutRedirectUri?: string;
    acrValues?: string;
    responseType?: string;
    loadUserInfo?: boolean;
    scope?: string;
    serverClientId?: string;
    serverClientSecret?: string;
    accountApiUrl?: string;
    contactsApiUrl?: string;
    messengerApiUrl?: string;
    accessControlApiUrl?: string;
    pmsConnectorApiUrl?: string;
    singleSourceApiUrl?: string;
    productApiUrl?: string;
    contactDomain?: string;
    phoneDomain?: string;
    featureFlagsDomain?: string;
    unifiedWrapperDomain?: string;
    textSenderApiUrl?: string;
    fdaApiUrl?: string;
    intercomAppId?: string;
    appointmentApiUrl?: string;
    universalPatientSearchApiUrl?: string;
    insuranceVerification2ApiUrl?: string;
    leadManagementMilaApiUrl?: string;
    userProfileApiUrl?: string;
    enterpriseFormsApiUrl?: string;
}

export class PatientDto implements IPatientDto {
    patientIndex?: number;
    rwContactId?: number;
    rwPatientId?: number | undefined;
    identityUserId?: string;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: Date | undefined;
    isResponsibleParty?: boolean;
    email?: string;
    phone?: string;
    cellPhone?: string;
    homePhone?: string;
    workPhone?: string;
    token?: string;
    tokenVerified?: boolean;
    tokenShort?: string | undefined;
    status?: PatientStatus;
    practiceUserId?: number | undefined;
    practiceUserAccountId?: number | undefined;
    practiceNetworkId?: number | undefined;
    practiceUserIsAuthenticated?: boolean | undefined;
    isSignedIn?: boolean | undefined;
    insurance?: string;
    address?: RwContactAddress | undefined;
    location?: LocationDto;
    formAssignments?: FormAssignmentDto[];
    familyMembers?: PatientDto[];
    insuranceInfo?: RwPatientInsuranceInfo | undefined;

    constructor(data?: IPatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientIndex = _data["patientIndex"];
            this.rwContactId = _data["rwContactId"];
            this.rwPatientId = _data["rwPatientId"];
            this.identityUserId = _data["identityUserId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.isResponsibleParty = _data["isResponsibleParty"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.homePhone = _data["homePhone"];
            this.workPhone = _data["workPhone"];
            this.token = _data["token"];
            this.tokenVerified = _data["tokenVerified"];
            this.tokenShort = _data["tokenShort"];
            this.status = _data["status"];
            this.practiceUserId = _data["practiceUserId"];
            this.practiceUserAccountId = _data["practiceUserAccountId"];
            this.practiceNetworkId = _data["practiceNetworkId"];
            this.practiceUserIsAuthenticated = _data["practiceUserIsAuthenticated"];
            this.isSignedIn = _data["isSignedIn"];
            this.insurance = _data["insurance"];
            this.address = _data["address"] ? RwContactAddress.fromJS(_data["address"]) : <any>undefined;
            this.location = _data["location"] ? LocationDto.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["formAssignments"])) {
                this.formAssignments = [] as any;
                for (let item of _data["formAssignments"])
                    this.formAssignments!.push(FormAssignmentDto.fromJS(item));
            }
            if (Array.isArray(_data["familyMembers"])) {
                this.familyMembers = [] as any;
                for (let item of _data["familyMembers"])
                    this.familyMembers!.push(PatientDto.fromJS(item));
            }
            this.insuranceInfo = _data["insuranceInfo"] ? RwPatientInsuranceInfo.fromJS(_data["insuranceInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientIndex"] = this.patientIndex;
        data["rwContactId"] = this.rwContactId;
        data["rwPatientId"] = this.rwPatientId;
        data["identityUserId"] = this.identityUserId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["isResponsibleParty"] = this.isResponsibleParty;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["homePhone"] = this.homePhone;
        data["workPhone"] = this.workPhone;
        data["token"] = this.token;
        data["tokenVerified"] = this.tokenVerified;
        data["tokenShort"] = this.tokenShort;
        data["status"] = this.status;
        data["practiceUserId"] = this.practiceUserId;
        data["practiceUserAccountId"] = this.practiceUserAccountId;
        data["practiceNetworkId"] = this.practiceNetworkId;
        data["practiceUserIsAuthenticated"] = this.practiceUserIsAuthenticated;
        data["isSignedIn"] = this.isSignedIn;
        data["insurance"] = this.insurance;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.formAssignments)) {
            data["formAssignments"] = [];
            for (let item of this.formAssignments)
                data["formAssignments"].push(item.toJSON());
        }
        if (Array.isArray(this.familyMembers)) {
            data["familyMembers"] = [];
            for (let item of this.familyMembers)
                data["familyMembers"].push(item.toJSON());
        }
        data["insuranceInfo"] = this.insuranceInfo ? this.insuranceInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPatientDto {
    patientIndex?: number;
    rwContactId?: number;
    rwPatientId?: number | undefined;
    identityUserId?: string;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: Date | undefined;
    isResponsibleParty?: boolean;
    email?: string;
    phone?: string;
    cellPhone?: string;
    homePhone?: string;
    workPhone?: string;
    token?: string;
    tokenVerified?: boolean;
    tokenShort?: string | undefined;
    status?: PatientStatus;
    practiceUserId?: number | undefined;
    practiceUserAccountId?: number | undefined;
    practiceNetworkId?: number | undefined;
    practiceUserIsAuthenticated?: boolean | undefined;
    isSignedIn?: boolean | undefined;
    insurance?: string;
    address?: RwContactAddress | undefined;
    location?: LocationDto;
    formAssignments?: FormAssignmentDto[];
    familyMembers?: PatientDto[];
    insuranceInfo?: RwPatientInsuranceInfo | undefined;
}

export enum PatientStatus {
    Fail = 0,
    Succeed = 1,
    PreviouslyCreated = 2,
}

export class RwPatientInsuranceInfo implements IRwPatientInsuranceInfo {
    subscriberFirstName?: string | undefined;
    subscriberLastName?: string | undefined;
    subscriberPostalCode?: string | undefined;
    subscriberDateOfBirth?: Date | undefined;
    groupId?: string | undefined;
    memberId?: string | undefined;
    carrierId?: string | undefined;
    beginningMonth?: number | undefined;
    relation?: number;
    employerName?: string | undefined;

    constructor(data?: IRwPatientInsuranceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriberFirstName = _data["subscriberFirstName"];
            this.subscriberLastName = _data["subscriberLastName"];
            this.subscriberPostalCode = _data["subscriberPostalCode"];
            this.subscriberDateOfBirth = _data["subscriberDateOfBirth"] ? new Date(_data["subscriberDateOfBirth"].toString()) : <any>undefined;
            this.groupId = _data["groupId"];
            this.memberId = _data["memberId"];
            this.carrierId = _data["carrierId"];
            this.beginningMonth = _data["beginningMonth"];
            this.relation = _data["relation"];
            this.employerName = _data["employerName"];
        }
    }

    static fromJS(data: any): RwPatientInsuranceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RwPatientInsuranceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriberFirstName"] = this.subscriberFirstName;
        data["subscriberLastName"] = this.subscriberLastName;
        data["subscriberPostalCode"] = this.subscriberPostalCode;
        data["subscriberDateOfBirth"] = this.subscriberDateOfBirth ? this.subscriberDateOfBirth.toISOString() : <any>undefined;
        data["groupId"] = this.groupId;
        data["memberId"] = this.memberId;
        data["carrierId"] = this.carrierId;
        data["beginningMonth"] = this.beginningMonth;
        data["relation"] = this.relation;
        data["employerName"] = this.employerName;
        return data;
    }
}

export interface IRwPatientInsuranceInfo {
    subscriberFirstName?: string | undefined;
    subscriberLastName?: string | undefined;
    subscriberPostalCode?: string | undefined;
    subscriberDateOfBirth?: Date | undefined;
    groupId?: string | undefined;
    memberId?: string | undefined;
    carrierId?: string | undefined;
    beginningMonth?: number | undefined;
    relation?: number;
    employerName?: string | undefined;
}

export class GetPatientQuery implements IGetPatientQuery {

    constructor(data?: IGetPatientQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPatientQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPatientQuery {
}

export class PatientFormDto implements IPatientFormDto {
    id?: string;
    name?: string;
    type?: string;
    form2FormId?: string;
    form2PacketId?: string;
    link?: string;
    isForms2?: boolean;

    constructor(data?: IPatientFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.form2FormId = _data["form2FormId"];
            this.form2PacketId = _data["form2PacketId"];
            this.link = _data["link"];
            this.isForms2 = _data["isForms2"];
        }
    }

    static fromJS(data: any): PatientFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["form2FormId"] = this.form2FormId;
        data["form2PacketId"] = this.form2PacketId;
        data["link"] = this.link;
        data["isForms2"] = this.isForms2;
        return data;
    }
}

export interface IPatientFormDto {
    id?: string;
    name?: string;
    type?: string;
    form2FormId?: string;
    form2PacketId?: string;
    link?: string;
    isForms2?: boolean;
}

export class PatientFormAssignmentsForSearchDto implements IPatientFormAssignmentsForSearchDto {
    formAssignments?: FormAssignmentDto[];
    contact?: RwContactDto;

    constructor(data?: IPatientFormAssignmentsForSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formAssignments"])) {
                this.formAssignments = [] as any;
                for (let item of _data["formAssignments"])
                    this.formAssignments!.push(FormAssignmentDto.fromJS(item));
            }
            this.contact = _data["contact"] ? RwContactDto.fromJS(_data["contact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientFormAssignmentsForSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFormAssignmentsForSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formAssignments)) {
            data["formAssignments"] = [];
            for (let item of this.formAssignments)
                data["formAssignments"].push(item.toJSON());
        }
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPatientFormAssignmentsForSearchDto {
    formAssignments?: FormAssignmentDto[];
    contact?: RwContactDto;
}

export class CreatePatientFormAssignmentCommand implements ICreatePatientFormAssignmentCommand {
    formId?: string | undefined;
    packetId?: string | undefined;
    patientId?: number;

    constructor(data?: ICreatePatientFormAssignmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.packetId = _data["packetId"];
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): CreatePatientFormAssignmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientFormAssignmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["packetId"] = this.packetId;
        data["patientId"] = this.patientId;
        return data;
    }
}

export interface ICreatePatientFormAssignmentCommand {
    formId?: string | undefined;
    packetId?: string | undefined;
    patientId?: number;
}

export class PatientsWithFormAssignmentVm implements IPatientsWithFormAssignmentVm {
    mode?: Mode;
    patients?: PatientDto[];

    constructor(data?: IPatientsWithFormAssignmentVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(PatientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientsWithFormAssignmentVm {
        data = typeof data === 'object' ? data : {};
        let result = new PatientsWithFormAssignmentVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientsWithFormAssignmentVm {
    mode?: Mode;
    patients?: PatientDto[];
}

export enum Mode {
    None = 0,
    Tablet = 1,
    SignedInAs = 2,
}

export class GetPatientWithAssignmentsVmQuery implements IGetPatientWithAssignmentsVmQuery {

    constructor(data?: IGetPatientWithAssignmentsVmQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPatientWithAssignmentsVmQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientWithAssignmentsVmQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPatientWithAssignmentsVmQuery {
}

export class PatientSearchVm implements IPatientSearchVm {
    specialties?: KeyValuePairOfSpecialtyAndString[];

    constructor(data?: IPatientSearchVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["specialties"])) {
                this.specialties = [] as any;
                for (let item of _data["specialties"])
                    this.specialties!.push(KeyValuePairOfSpecialtyAndString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientSearchVm {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSearchVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.specialties)) {
            data["specialties"] = [];
            for (let item of this.specialties)
                data["specialties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientSearchVm {
    specialties?: KeyValuePairOfSpecialtyAndString[];
}

export class GetPatientSearchVmQuery implements IGetPatientSearchVmQuery {

    constructor(data?: IGetPatientSearchVmQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPatientSearchVmQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientSearchVmQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPatientSearchVmQuery {
}

export class InvitePatientCommand implements IInvitePatientCommand {
    patientId?: number;
    method?: PatientInviteMethod;
    shortenUrl?: boolean | undefined;

    constructor(data?: IInvitePatientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.method = _data["method"];
            this.shortenUrl = _data["shortenUrl"];
        }
    }

    static fromJS(data: any): InvitePatientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InvitePatientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["method"] = this.method;
        data["shortenUrl"] = this.shortenUrl;
        return data;
    }
}

export interface IInvitePatientCommand {
    patientId?: number;
    method?: PatientInviteMethod;
    shortenUrl?: boolean | undefined;
}

export enum PatientInviteMethod {
    Email = 0,
    QrCode = 1,
    SMS = 2,
    SignInAs = 3,
}

export class LoginPatientCommand implements ILoginPatientCommand {
    userId?: string | undefined;
    emailOrPhone?: string;
    dateOfBirth?: string;
    rwLocationId?: number;
    token?: string;
    sendNewToken?: boolean;

    constructor(data?: ILoginPatientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.emailOrPhone = _data["emailOrPhone"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.rwLocationId = _data["rwLocationId"];
            this.token = _data["token"];
            this.sendNewToken = _data["sendNewToken"];
        }
    }

    static fromJS(data: any): LoginPatientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LoginPatientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["emailOrPhone"] = this.emailOrPhone;
        data["dateOfBirth"] = this.dateOfBirth;
        data["rwLocationId"] = this.rwLocationId;
        data["token"] = this.token;
        data["sendNewToken"] = this.sendNewToken;
        return data;
    }
}

export interface ILoginPatientCommand {
    userId?: string | undefined;
    emailOrPhone?: string;
    dateOfBirth?: string;
    rwLocationId?: number;
    token?: string;
    sendNewToken?: boolean;
}

export class RegisterPatientCommand implements IRegisterPatientCommand {
    locationIndex?: number;
    firstName?: string;
    lastName?: string;
    emailOrPhone?: string;
    dateOfBirth?: string;
    formsId?: string;
    type?: string;

    constructor(data?: IRegisterPatientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationIndex = _data["locationIndex"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailOrPhone = _data["emailOrPhone"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.formsId = _data["formsId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RegisterPatientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterPatientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationIndex"] = this.locationIndex;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailOrPhone"] = this.emailOrPhone;
        data["dateOfBirth"] = this.dateOfBirth;
        data["formsId"] = this.formsId;
        data["type"] = this.type;
        return data;
    }
}

export interface IRegisterPatientCommand {
    locationIndex?: number;
    firstName?: string;
    lastName?: string;
    emailOrPhone?: string;
    dateOfBirth?: string;
    formsId?: string;
    type?: string;
}

export class PatientSearchDto implements IPatientSearchDto {
    rwPatientId?: number;
    name?: string;
    assignedForms?: number;
    dateOfBirth?: string;
    gender?: string;

    constructor(data?: IPatientSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rwPatientId = _data["rwPatientId"];
            this.name = _data["name"];
            this.assignedForms = _data["assignedForms"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): PatientSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rwPatientId"] = this.rwPatientId;
        data["name"] = this.name;
        data["assignedForms"] = this.assignedForms;
        data["dateOfBirth"] = this.dateOfBirth;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IPatientSearchDto {
    rwPatientId?: number;
    name?: string;
    assignedForms?: number;
    dateOfBirth?: string;
    gender?: string;
}

export class GetPatientLogoutQuery implements IGetPatientLogoutQuery {

    constructor(data?: IGetPatientLogoutQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPatientLogoutQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientLogoutQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPatientLogoutQuery {
}

export class CreatePatientsFormAssignmentsCommand implements ICreatePatientsFormAssignmentsCommand {
    formIds?: string[];
    packetIds?: string[];
    patients?: PatientDto[];

    constructor(data?: ICreatePatientsFormAssignmentsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            if (Array.isArray(_data["packetIds"])) {
                this.packetIds = [] as any;
                for (let item of _data["packetIds"])
                    this.packetIds!.push(item);
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(PatientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePatientsFormAssignmentsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientsFormAssignmentsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        if (Array.isArray(this.packetIds)) {
            data["packetIds"] = [];
            for (let item of this.packetIds)
                data["packetIds"].push(item);
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreatePatientsFormAssignmentsCommand {
    formIds?: string[];
    packetIds?: string[];
    patients?: PatientDto[];
}

export class PatientsWithFormsDueDateLocation implements IPatientsWithFormsDueDateLocation {
    locationId?: number;
    patientIds?: number[];

    constructor(data?: IPatientsWithFormsDueDateLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["patientIds"])) {
                this.patientIds = [] as any;
                for (let item of _data["patientIds"])
                    this.patientIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PatientsWithFormsDueDateLocation {
        data = typeof data === 'object' ? data : {};
        let result = new PatientsWithFormsDueDateLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        if (Array.isArray(this.patientIds)) {
            data["patientIds"] = [];
            for (let item of this.patientIds)
                data["patientIds"].push(item);
        }
        return data;
    }
}

export interface IPatientsWithFormsDueDateLocation {
    locationId?: number;
    patientIds?: number[];
}

export class GetPatientsWithFormsDueDateQuery implements IGetPatientsWithFormsDueDateQuery {
    locationIds?: number[];
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IGetPatientsWithFormsDueDateQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPatientsWithFormsDueDateQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientsWithFormsDueDateQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetPatientsWithFormsDueDateQuery {
    locationIds?: number[];
    startDate?: Date;
    endDate?: Date;
}

export class PatientAppointmentDto implements IPatientAppointmentDto {
    id?: number;
    patientId?: number | undefined;
    patientName?: string;
    startDate?: Date;
    endDate?: Date | undefined;
    status?: AppointmentStatus;
    assignedFormCount?: number | undefined;
    completedFormCount?: number | undefined;

    constructor(data?: IPatientAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patientId = _data["patientId"];
            this.patientName = _data["patientName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.assignedFormCount = _data["assignedFormCount"];
            this.completedFormCount = _data["completedFormCount"];
        }
    }

    static fromJS(data: any): PatientAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patientId"] = this.patientId;
        data["patientName"] = this.patientName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["assignedFormCount"] = this.assignedFormCount;
        data["completedFormCount"] = this.completedFormCount;
        return data;
    }
}

export interface IPatientAppointmentDto {
    id?: number;
    patientId?: number | undefined;
    patientName?: string;
    startDate?: Date;
    endDate?: Date | undefined;
    status?: AppointmentStatus;
    assignedFormCount?: number | undefined;
    completedFormCount?: number | undefined;
}

export enum AppointmentStatus {
    Unconfirmed = 0,
    Confirmed = 1,
    Cancelled = 2,
    Deleted = 255,
}

export class MissingPatientDataFormAssignmentDto implements IMissingPatientDataFormAssignmentDto {
    patientLoginUrl?: string;
    formAssignmentIndex?: number;

    constructor(data?: IMissingPatientDataFormAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientLoginUrl = _data["patientLoginUrl"];
            this.formAssignmentIndex = _data["formAssignmentIndex"];
        }
    }

    static fromJS(data: any): MissingPatientDataFormAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissingPatientDataFormAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientLoginUrl"] = this.patientLoginUrl;
        data["formAssignmentIndex"] = this.formAssignmentIndex;
        return data;
    }
}

export interface IMissingPatientDataFormAssignmentDto {
    patientLoginUrl?: string;
    formAssignmentIndex?: number;
}

export class ProcessPatientMissingDataCommand implements IProcessPatientMissingDataCommand {
    missingPatientDataMessage?: UpcomingAppointmentMessage;

    constructor(data?: IProcessPatientMissingDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missingPatientDataMessage = _data["missingPatientDataMessage"] ? UpcomingAppointmentMessage.fromJS(_data["missingPatientDataMessage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcessPatientMissingDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessPatientMissingDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missingPatientDataMessage"] = this.missingPatientDataMessage ? this.missingPatientDataMessage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProcessPatientMissingDataCommand {
    missingPatientDataMessage?: UpcomingAppointmentMessage;
}

export class UpcomingAppointmentMessage implements IUpcomingAppointmentMessage {
    idPatient?: number;
    idAppointment?: number;
    idLocation?: number;
    communicationChannel?: string | undefined;

    constructor(data?: IUpcomingAppointmentMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPatient = _data["idPatient"];
            this.idAppointment = _data["idAppointment"];
            this.idLocation = _data["idLocation"];
            this.communicationChannel = _data["communicationChannel"];
        }
    }

    static fromJS(data: any): UpcomingAppointmentMessage {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingAppointmentMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPatient"] = this.idPatient;
        data["idAppointment"] = this.idAppointment;
        data["idLocation"] = this.idLocation;
        data["communicationChannel"] = this.communicationChannel;
        return data;
    }
}

export interface IUpcomingAppointmentMessage {
    idPatient?: number;
    idAppointment?: number;
    idLocation?: number;
    communicationChannel?: string | undefined;
}

export abstract class BaseFormsResponse implements IBaseFormsResponse {
    isSuccess?: boolean;
    errorDetails?: ErrorDetails | undefined;

    constructor(data?: IBaseFormsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.errorDetails = _data["errorDetails"] ? ErrorDetails.fromJS(_data["errorDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseFormsResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseFormsResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["errorDetails"] = this.errorDetails ? this.errorDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseFormsResponse {
    isSuccess?: boolean;
    errorDetails?: ErrorDetails | undefined;
}

export class GetLocationsInfoResponse extends BaseFormsResponse implements IGetLocationsInfoResponse {
    locations?: Location[] | undefined;
    selectedLocationId?: number;

    constructor(data?: IGetLocationsInfoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            this.selectedLocationId = _data["selectedLocationId"];
        }
    }

    static override fromJS(data: any): GetLocationsInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationsInfoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["selectedLocationId"] = this.selectedLocationId;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLocationsInfoResponse extends IBaseFormsResponse {
    locations?: Location[] | undefined;
    selectedLocationId?: number;
}

export class Location implements ILocation {
    id?: number;
    zoneId?: string | undefined;
    name?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    unlockPin?: string | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.zoneId = _data["zoneId"];
            this.name = _data["name"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.unlockPin = _data["unlockPin"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["zoneId"] = this.zoneId;
        data["name"] = this.name;
        data["state"] = this.state;
        data["city"] = this.city;
        data["address"] = this.address;
        data["unlockPin"] = this.unlockPin;
        return data;
    }
}

export interface ILocation {
    id?: number;
    zoneId?: string | undefined;
    name?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    unlockPin?: string | undefined;
}

export class ErrorDetails implements IErrorDetails {
    code?: ErrorCode;
    message?: string | undefined;

    constructor(data?: IErrorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ErrorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IErrorDetails {
    code?: ErrorCode;
    message?: string | undefined;
}

export enum ErrorCode {
    DoesNotHaveAccessToResource = 1,
    OutdatedApiVersion = 1200,
    LocationDoesNotHaveForms2 = 1300,
}

export class GetLocationsInfoQuery implements IGetLocationsInfoQuery {

    constructor(data?: IGetLocationsInfoQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetLocationsInfoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationsInfoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetLocationsInfoQuery {
}

export class GetLocationInfoQuery implements IGetLocationInfoQuery {
    locationId?: number;

    constructor(data?: IGetLocationInfoQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): GetLocationInfoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationInfoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface IGetLocationInfoQuery {
    locationId?: number;
}

export class GetPatientListResponse extends BaseFormsResponse implements IGetPatientListResponse {
    patients?: PatientInfo[] | undefined;

    constructor(data?: IGetPatientListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(PatientInfo.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetPatientListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPatientListResponse extends IBaseFormsResponse {
    patients?: PatientInfo[] | undefined;
}

export class PatientInfo implements IPatientInfo {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    pmsId?: string | undefined;
    dateOfBirth?: Date | undefined;
    cellPhone?: string | undefined;
    primaryPhone?: string | undefined;
    secondaryPhone?: string | undefined;
    gender?: Gender;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    profileImage?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    age?: number | undefined;
    birthdayToString?: string | undefined;
    cellPhoneToString?: string | undefined;
    primaryPhoneToString?: string | undefined;
    secondaryPhoneToString?: string | undefined;

    constructor(data?: IPatientInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.pmsId = _data["pmsId"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.cellPhone = _data["cellPhone"];
            this.primaryPhone = _data["primaryPhone"];
            this.secondaryPhone = _data["secondaryPhone"];
            this.gender = _data["gender"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.profileImage = _data["profileImage"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.age = _data["age"];
            this.birthdayToString = _data["birthdayToString"];
            this.cellPhoneToString = _data["cellPhoneToString"];
            this.primaryPhoneToString = _data["primaryPhoneToString"];
            this.secondaryPhoneToString = _data["secondaryPhoneToString"];
        }
    }

    static fromJS(data: any): PatientInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["pmsId"] = this.pmsId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["cellPhone"] = this.cellPhone;
        data["primaryPhone"] = this.primaryPhone;
        data["secondaryPhone"] = this.secondaryPhone;
        data["gender"] = this.gender;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["profileImage"] = this.profileImage;
        data["email"] = this.email;
        data["name"] = this.name;
        data["age"] = this.age;
        data["birthdayToString"] = this.birthdayToString;
        data["cellPhoneToString"] = this.cellPhoneToString;
        data["primaryPhoneToString"] = this.primaryPhoneToString;
        data["secondaryPhoneToString"] = this.secondaryPhoneToString;
        return data;
    }
}

export interface IPatientInfo {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    pmsId?: string | undefined;
    dateOfBirth?: Date | undefined;
    cellPhone?: string | undefined;
    primaryPhone?: string | undefined;
    secondaryPhone?: string | undefined;
    gender?: Gender;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    profileImage?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    age?: number | undefined;
    birthdayToString?: string | undefined;
    cellPhoneToString?: string | undefined;
    primaryPhoneToString?: string | undefined;
    secondaryPhoneToString?: string | undefined;
}

export enum Gender {
    Male = 0,
    Female = 1,
}

export class GetPatientListQuery implements IGetPatientListQuery {
    locationId?: number;
    appointmentDate?: Date;

    constructor(data?: IGetPatientListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.appointmentDate = _data["appointmentDate"] ? new Date(_data["appointmentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPatientListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetPatientListQuery {
    locationId?: number;
    appointmentDate?: Date;
}

export class UploadDocumentFileResponse extends BaseFormsResponse implements IUploadDocumentFileResponse {
    fileId?: number;

    constructor(data?: IUploadDocumentFileResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileId = _data["fileId"];
        }
    }

    static override fromJS(data: any): UploadDocumentFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadDocumentFileResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        super.toJSON(data);
        return data;
    }
}

export interface IUploadDocumentFileResponse extends IBaseFormsResponse {
    fileId?: number;
}

export class UploadDocumentFileCommand implements IUploadDocumentFileCommand {
    locationId?: number;
    fileExtension?: string;
    fileContent?: string;
    pagesMetadata?: PageMetadata[];

    constructor(data?: IUploadDocumentFileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.fileExtension = _data["fileExtension"];
            this.fileContent = _data["fileContent"];
            if (Array.isArray(_data["pagesMetadata"])) {
                this.pagesMetadata = [] as any;
                for (let item of _data["pagesMetadata"])
                    this.pagesMetadata!.push(PageMetadata.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadDocumentFileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UploadDocumentFileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["fileExtension"] = this.fileExtension;
        data["fileContent"] = this.fileContent;
        if (Array.isArray(this.pagesMetadata)) {
            data["pagesMetadata"] = [];
            for (let item of this.pagesMetadata)
                data["pagesMetadata"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUploadDocumentFileCommand {
    locationId?: number;
    fileExtension?: string;
    fileContent?: string;
    pagesMetadata?: PageMetadata[];
}

export class PageMetadata implements IPageMetadata {
    index?: number;
    width?: number;
    height?: number;
    horizontalResolution?: number;
    verticalResolution?: number;
    isValid?: boolean;

    constructor(data?: IPageMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.horizontalResolution = _data["horizontalResolution"];
            this.verticalResolution = _data["verticalResolution"];
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): PageMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new PageMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["width"] = this.width;
        data["height"] = this.height;
        data["horizontalResolution"] = this.horizontalResolution;
        data["verticalResolution"] = this.verticalResolution;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IPageMetadata {
    index?: number;
    width?: number;
    height?: number;
    horizontalResolution?: number;
    verticalResolution?: number;
    isValid?: boolean;
}

export class AddPrintedFormResponse extends BaseFormsResponse implements IAddPrintedFormResponse {
    formId?: number;
    formLink?: string | undefined;
    formPreviewLink?: string | undefined;

    constructor(data?: IAddPrintedFormResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.formId = _data["formId"];
            this.formLink = _data["formLink"];
            this.formPreviewLink = _data["formPreviewLink"];
        }
    }

    static override fromJS(data: any): AddPrintedFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddPrintedFormResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formLink"] = this.formLink;
        data["formPreviewLink"] = this.formPreviewLink;
        super.toJSON(data);
        return data;
    }
}

export interface IAddPrintedFormResponse extends IBaseFormsResponse {
    formId?: number;
    formLink?: string | undefined;
    formPreviewLink?: string | undefined;
}

export class AddPrintedFormCommand implements IAddPrintedFormCommand {
    locationId?: number;
    patientId?: number;
    fileName?: string;
    fileId?: number;

    constructor(data?: IAddPrintedFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.patientId = _data["patientId"];
            this.fileName = _data["fileName"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): AddPrintedFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddPrintedFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["patientId"] = this.patientId;
        data["fileName"] = this.fileName;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IAddPrintedFormCommand {
    locationId?: number;
    patientId?: number;
    fileName?: string;
    fileId?: number;
}

export class FindPatientResponse extends BaseFormsResponse implements IFindPatientResponse {
    patients?: PatientInfo[] | undefined;

    constructor(data?: IFindPatientResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(PatientInfo.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FindPatientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FindPatientResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFindPatientResponse extends IBaseFormsResponse {
    patients?: PatientInfo[] | undefined;
}

export class GetPatientQuery2 implements IGetPatientQuery2 {
    locationId?: number;
    searchString?: string;

    constructor(data?: IGetPatientQuery2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.searchString = _data["searchString"];
        }
    }

    static fromJS(data: any): GetPatientQuery2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientQuery2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["searchString"] = this.searchString;
        return data;
    }
}

export interface IGetPatientQuery2 {
    locationId?: number;
    searchString?: string;
}

export class SetPrintedFormActiveResponse extends BaseFormsResponse implements ISetPrintedFormActiveResponse {

    constructor(data?: ISetPrintedFormActiveResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SetPrintedFormActiveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetPrintedFormActiveResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetPrintedFormActiveResponse extends IBaseFormsResponse {
}

export class SetPrintedFormActiveCommand implements ISetPrintedFormActiveCommand {
    locationId?: number;
    formId?: number;

    constructor(data?: ISetPrintedFormActiveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.formId = _data["formId"];
        }
    }

    static fromJS(data: any): SetPrintedFormActiveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetPrintedFormActiveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["formId"] = this.formId;
        return data;
    }
}

export interface ISetPrintedFormActiveCommand {
    locationId?: number;
    formId?: number;
}

export class CheckPrintedDocumentStatusResponse extends BaseFormsResponse implements ICheckPrintedDocumentStatusResponse {
    formIds?: number[] | undefined;

    constructor(data?: ICheckPrintedDocumentStatusResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): CheckPrintedDocumentStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPrintedDocumentStatusResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICheckPrintedDocumentStatusResponse extends IBaseFormsResponse {
    formIds?: number[] | undefined;
}

export class CheckPrintedDocumentStatusQuery implements ICheckPrintedDocumentStatusQuery {
    locationId?: number;
    formIds?: number[];

    constructor(data?: ICheckPrintedDocumentStatusQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CheckPrintedDocumentStatusQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPrintedDocumentStatusQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        return data;
    }
}

export interface ICheckPrintedDocumentStatusQuery {
    locationId?: number;
    formIds?: number[];
}

export class SetPrintedFormAcceptanceBlockResponse extends BaseFormsResponse implements ISetPrintedFormAcceptanceBlockResponse {

    constructor(data?: ISetPrintedFormAcceptanceBlockResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SetPrintedFormAcceptanceBlockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetPrintedFormAcceptanceBlockResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetPrintedFormAcceptanceBlockResponse extends IBaseFormsResponse {
}

export class SetPrintedFormAcceptanceBlockCommand implements ISetPrintedFormAcceptanceBlockCommand {
    locationId?: number;
    formId?: number;
    acceptanceBlock?: PrintedFormAcceptanceBlock | undefined;

    constructor(data?: ISetPrintedFormAcceptanceBlockCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.formId = _data["formId"];
            this.acceptanceBlock = _data["acceptanceBlock"] ? PrintedFormAcceptanceBlock.fromJS(_data["acceptanceBlock"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SetPrintedFormAcceptanceBlockCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetPrintedFormAcceptanceBlockCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["formId"] = this.formId;
        data["acceptanceBlock"] = this.acceptanceBlock ? this.acceptanceBlock.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetPrintedFormAcceptanceBlockCommand {
    locationId?: number;
    formId?: number;
    acceptanceBlock?: PrintedFormAcceptanceBlock | undefined;
}

export class PrintedFormAcceptanceBlock implements IPrintedFormAcceptanceBlock {
    header?: string | undefined;
    question?: string | undefined;

    constructor(data?: IPrintedFormAcceptanceBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.question = _data["question"];
        }
    }

    static fromJS(data: any): PrintedFormAcceptanceBlock {
        data = typeof data === 'object' ? data : {};
        let result = new PrintedFormAcceptanceBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["question"] = this.question;
        return data;
    }
}

export interface IPrintedFormAcceptanceBlock {
    header?: string | undefined;
    question?: string | undefined;
}

export class GetDefaultAcceptanceBlockResponse extends BaseFormsResponse implements IGetDefaultAcceptanceBlockResponse {
    acceptanceBlock?: PrintedFormAcceptanceBlock | undefined;

    constructor(data?: IGetDefaultAcceptanceBlockResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.acceptanceBlock = _data["acceptanceBlock"] ? PrintedFormAcceptanceBlock.fromJS(_data["acceptanceBlock"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetDefaultAcceptanceBlockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultAcceptanceBlockResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acceptanceBlock"] = this.acceptanceBlock ? this.acceptanceBlock.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDefaultAcceptanceBlockResponse extends IBaseFormsResponse {
    acceptanceBlock?: PrintedFormAcceptanceBlock | undefined;
}

export class GetDefaultAcceptanceBlockQuery implements IGetDefaultAcceptanceBlockQuery {
    locationId?: number;

    constructor(data?: IGetDefaultAcceptanceBlockQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): GetDefaultAcceptanceBlockQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultAcceptanceBlockQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface IGetDefaultAcceptanceBlockQuery {
    locationId?: number;
}

export class SetDefaultAcceptanceBlockCommand implements ISetDefaultAcceptanceBlockCommand {
    rwLocationId?: number;
    header?: string;
    question?: string;

    constructor(data?: ISetDefaultAcceptanceBlockCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rwLocationId = _data["rwLocationId"];
            this.header = _data["header"];
            this.question = _data["question"];
        }
    }

    static fromJS(data: any): SetDefaultAcceptanceBlockCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultAcceptanceBlockCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rwLocationId"] = this.rwLocationId;
        data["header"] = this.header;
        data["question"] = this.question;
        return data;
    }
}

export interface ISetDefaultAcceptanceBlockCommand {
    rwLocationId?: number;
    header?: string;
    question?: string;
}

export class SendEmailResponse extends BaseFormsResponse implements ISendEmailResponse {

    constructor(data?: ISendEmailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SendEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISendEmailResponse extends IBaseFormsResponse {
}

export class SendEmailCommand implements ISendEmailCommand {
    locationId?: number;
    subject?: string;
    email?: string;
    body?: string;

    constructor(data?: ISendEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.subject = _data["subject"];
            this.email = _data["email"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): SendEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["subject"] = this.subject;
        data["email"] = this.email;
        data["body"] = this.body;
        return data;
    }
}

export interface ISendEmailCommand {
    locationId?: number;
    subject?: string;
    email?: string;
    body?: string;
}

export class GetPatientFormEmailTemplateResponse extends BaseFormsResponse implements IGetPatientFormEmailTemplateResponse {
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: IGetPatientFormEmailTemplateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static override fromJS(data: any): GetPatientFormEmailTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientFormEmailTemplateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["body"] = this.body;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPatientFormEmailTemplateResponse extends IBaseFormsResponse {
    subject?: string | undefined;
    body?: string | undefined;
}

export class GetPatientFormEmailTemplateQuery implements IGetPatientFormEmailTemplateQuery {
    locationId?: number;
    patientId?: number;

    constructor(data?: IGetPatientFormEmailTemplateQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): GetPatientFormEmailTemplateQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientFormEmailTemplateQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["patientId"] = this.patientId;
        return data;
    }
}

export interface IGetPatientFormEmailTemplateQuery {
    locationId?: number;
    patientId?: number;
}

export class GetPrinterDownloadUrlQuery implements IGetPrinterDownloadUrlQuery {
    x64Version?: boolean;

    constructor(data?: IGetPrinterDownloadUrlQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x64Version = _data["x64Version"];
        }
    }

    static fromJS(data: any): GetPrinterDownloadUrlQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrinterDownloadUrlQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x64Version"] = this.x64Version;
        return data;
    }
}

export interface IGetPrinterDownloadUrlQuery {
    x64Version?: boolean;
}

export class UserDto implements IUserDto {
    userId?: number | undefined;
    pin?: number;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["pin"] = this.pin;
        return data;
    }
}

export interface IUserDto {
    userId?: number | undefined;
    pin?: number;
}

export class GetUserQuery implements IGetUserQuery {

    constructor(data?: IGetUserQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetUserQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetUserQuery {
}

export class AddUpdateUserPinCommand implements IAddUpdateUserPinCommand {
    pin?: number;

    constructor(data?: IAddUpdateUserPinCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): AddUpdateUserPinCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddUpdateUserPinCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pin"] = this.pin;
        return data;
    }
}

export interface IAddUpdateUserPinCommand {
    pin?: number;
}

export class AuthenticateUserByPinCommand implements IAuthenticateUserByPinCommand {
    pin?: number;

    constructor(data?: IAuthenticateUserByPinCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): AuthenticateUserByPinCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateUserByPinCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pin"] = this.pin;
        return data;
    }
}

export interface IAuthenticateUserByPinCommand {
    pin?: number;
}

export class LoginCommand implements ILoginCommand {
    locationId?: number;

    constructor(data?: ILoginCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): LoginCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface ILoginCommand {
    locationId?: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}